export const translation = {
    "pl": {
        "LOGIN": {
            "USERNAME": "Login",
            "PASSWORD": "Hasło",
            "LOGIN_REQUIRED_INFO": "Podaj login zarejestrowany w systemie",
            "SEND_PASSWORD_HEADER": "Zresetuj hasło",
            "RECOVER_HEADER": "E-mail został wysłany",
            "BUTTON": {
                "LOGIN": "Zaloguj"
            },
            "LOG_IN": "Logowanie do systemu",
            "APP_NAME": "EH24",
            "APP_NAME_ALTERNATIVE": "Portal Pośrednika",
            "APP_SUBNAME": "Aplikacja pomocnicza",
            "INFORMATION": "Użyj dotychczasowych danych do logowania w systemie sprzedażowym. Jeżeli hasło nie działa, a było zmieniane w ciągu ostatniego tygodnia, wpisz poprzednie.",
            "INVALID_CREDENTIALS": "Nieprawidłowe dane logowania"
        },
        "LABEL": {
            "PASSWORD": {
                "RESET_INFORMATION": "W celu zresetowania hasła podaj nazwę użytkownika.",
                "RESET_DIALOG": "Jeżeli podane konto istnieje w systemie to na przypisany do konta email zostanie wysłana wiadomości z informacją jak zresetować hasło.",
                "INFORMATION": "Wystąpiłeś o zmianę hasła. Hasło powinno zawierać przynajmniej 8 znaków oraz powinno zawierać znaki z przynajmniej trzech z następujących grup znaków:<br/>\n<ul>\n<li>małe litery</li>\n<li>wielkie litery</li>\n<li>cyfry</li>\n<li>znaki specjalne</li>\n</ul>",
                "NEW_PASSWORD": "Nowe hasło",
                "NEW_PASSWORD_REPEAT": "Powtórz nowe hasło",
                "RESET_DIALOG_SUCCESS": "Hasło zostało zmienione, zostaniesz przeniesiony do strony logowania."
            },
            "FILE_NAME": "Nazwa dokumentu",
            "CALCULATION_PRINTOUT": "Wydruk kalkulacji",
            "OFFER_PRINTOUT": "Wydruk oferty",
            "POLICY_PRINTOUT": "Wydruk polisy",
            "SUMMARY_PRINTOUT": "Wydruk podsumowania",
            "CERTIFICATE_PRINTOUT": "Wydruk certyfikatu",
            "PAGINATOR": "{{page}} z {{pages}}",
            "SELLER": "Pośrednik",
            "ROLE": {
                "AGENT": "Agent",
                "WORKER": "OFWCA",
                "DIRECT_SALES": "Sprzedaż bezpośrednia",
                "SALES_MANAGER": "Menadżer Sprzedazy",
                "HEADQUATERS": "Centrala"
            },
            "LOGGED_OUT_HEADER": "Informacja",
            "LOGGED_OUT_DESCRIPTION": "Sesja wygasła",
            "YES": "Tak",
            "NO": "Nie",
            "PICK": "Wybierz",
            "NAME": "Imię",
            "SURNAME": "Nazwisko",
            "FAMILY_NAME": "Nazwisko rodowe",
            "PESEL": "PESEL",
            "NO_PESEL": "Brak numeru PESEL - obcokrajowiec",
            "FOREIGNER": "Obcokrajowiec",
            "POLICYHOLDER_INSURED": "Ubezpieczający / Ubezpieczony",
            "POLICYHOLDER": "Ubezpieczający",
            "INSURED": "Ubezpieczony",
            "INSURED_NUMBER": "Ubezpieczony {{index}}",
            "ADDRESS": "Adres zamieszkania",
            "ADDRESS_CORESPONDENCE": "Adres korespondencyjny",
            "BOTH_ADDRESSES": "Adres zamieszkania / korespondencyjny",
            "POST_CODE": "Kod pocztowy",
            "CITY": "Miasto",
            "STREET_PREFIX": "Przedrostek",
            "STREET": "Ulica",
            "STREET_NUMBER": "Numer ",
            "DOOR_NUMBER": "Numer mieszkania",
            "DIFFERENT_CORRESPONDENCE_ADDRESS": "Inny adres korespondencyjny",
            "INSURER_IS_INSURED": "Ubezpieczający jest jednocześnie Ubezpieczonym",
            "PREMIUM": "Składka",
            "NIP": "NIP",
            "REGON": "REGON",
            "GO_TO_CALCULATION": "Przejdź do kalkulacji",
            "CITIZENSHIP": "Obywatelstwo",
            "DATE_OF_BIRTH": "Data urodzenia",
            "GENDER": "Płeć",
            "DOCUMENT_TYPE": "Typ dokumentu",
            "DOCUMENT_NUMBER": "Numer dokumentu",
            "SUFFIX_KG": "kg",
            "SUFFIX_PLN": "zł",
            "SUFFIX_KM": "km",
            "SUFFIX_CM3": "cm³",
            "SUFFIX_KW": "kW",
            "CONFIRMATION": "Potwierdzenie",
            "POLICY_NUMBER": "Numer polisy",
            "OC": "OC",
            "AC": "AC",
            "SAVE_FAILED": "Na formularzu występują błędy",
            "GROWL_SUCCESS_TITLE": "Informacja",
            "GROWL_ERROR_TITLE": "Wystąpił błąd",
            "SELECT_FILTER": "Filtruj...",
            "SELECT_PLACEHOLDER": "-",
            "SUBMIT_CALCULATION": "Zatwierdź",
            "GENERATE_OFFER": "Generuj ofertę",
            "PHONE_NUMBER": "Nr telefonu",
            "EMAIL": "Email",
            "LOCATION_CHANGE_TITLE": "Definicja lokalizacji",
            "CREATION_DATE": "Utworzono",
            "CREATION_DATE_FROM": "Data utworzenia od",
            "CREATION_DATE_TO": "Data utworzenia do",
            "FRONTIER_HEADER": "OC Graniczne",
            "POLICYHOLDER_AND_INSURED": "Ubezpieczający / ubezpieczony",
            "GO_TO_SUMMARY": "Przejdź do podsumowania",
            "PHONE_PREFIX": "Prefiks",
            "VEHICLE_ORIGIN_COUNTRY": "Kraj rejestracji pojazdu",
            "COUNTRY": "Kraj",
            "PARTY_TYPE": "Typ",
            "COMPANY_NAME": "Nazwa firmy",
            "COMPANY_NUMBER": "Numer identyfikacyjny",
            "COMPANY_COUNTRY": "Kraj rejestracji firmy",
            "INSURANCE_PERIOD": "Długość ubezpieczenia",
            "PAYMENT": "Płatność",
            "PAYMENT_TYPE": "Metoda płatności",
            "PAYMENT_TYPE_HEADER1": "Preferowana metoda płatności - gotówka.",
            "PAYMENT_TYPE_HEADER2": "Opcja płatności przelewem powinna być wybierana wyłącznie wtedy, kiedy nie ma możliwości przyjęcia gotówki."
        },
        "ERROR": {
            "403": "Brak dostępu",
            "500": "Wystapił nieznany błąd",
            "PASSWORD_CHANGE_FAILURE": "Nie udało się zmienić hasła.",
            "TIMEOUT": "Przekroczono limit czasu odpowiedzi żądania",
            "FAILED_ROUTING_HEADER": "Błąd nawigacji",
            "FAILED_ROUTING_DESCRIPTION": "Nie udało się przejść do adresu {{url}}. Nastąpiło przekierowanie do strony głównej.",
            "PAYMENT_FAILED": "Nie udało się wystartować płatności."
        },
        "DASHBOARD": {
            "HEADER": "Dashboard",
            "NEW_OFFER": "Nowa oferta",
            "NEW_OFFER_SUB": "Majątek, komunikacja",
            "NEW_FRONTIER_SUB": "OC Graniczne",
            "REGISTRY": "Kartoteka",
            "REGISTRY_SUB": "Kalkulacje, oferty i polisy"
        },
        "HEADER": {
            "OPEN_MENU": "Otwórz menu"
        },
        "BUTTON": {
            "BACK": "Powrót",
            "CHANGE": "Zmień",
            "SAVE": "Zapisz",
            "CALCULATE": "Przelicz",
            "CONFIRM": "Potwierdź",
            "CLOSE": "Zamknij",
            "OK": "OK",
            "CANCEL": "Anuluj",
            "SEARCH": "Szukaj",
            "EXPORT_CSV": "Eksportuj do CSV",
            "ADD_INSURED": "Dodaj Ubezpieczonego",
            "REMOVE_INSURED": "Usuń Ubezpieczonego",
            "DOWNLOAD_ALL": "Pobierz wszystkie",
            "GO_TO_CALCULATION": "Przejdź do kalkulacji",
            "GO_TO_SUMMARY": "Przejdź do podsumowania",
            "NEXT": "Dalej",
            "ADD_CONTACT_DATA": "Dodaj dane kontaktowe",
            "EDIT_CONTACT_DATA": "Edytuj dane kontaktowe",
            "DELETE_CONTACT_DATA": "Usuń dane kontaktowe",
            "ADD_CESSION": "Dodaj cesję",
            "EDIT_CESSION": "Edytuj cesję",
            "DELETE_CESSION": "Usuń cesję",
            "ACCEPT_OFFER": "Zatwierdź ofertę",
            "SEND_OFFER": "Wyślij ofertę na e-mail",
            "GO_TO_OFFER": "Przejdź do oferty",
            "PAY": "Opłać",
            "PAYMENT_PENDING": "Płatność w trakcie",
            "PAYMENT_SUCCESS": "Opłacono"
        },
        "OFFER_CONFIG": {
            "NEW_OFFER": "Nowa oferta",
            "HEADER": "Kalkulacja oferty",
            "POLICY_DATA": "Dane polisowe",
            "TYPE_OF_POLICY": "Rodzaj polisy",
            "LAST_YEAR_POLICY_NR": "Numer polisy ubiegłorocznej",
            "PROTECTION_PERIOD": "Okres ochrony",
            "INSURANCE_DATE_FROM": "Data ubezpieczenia od",
            "INSURANCE_DATE_TO": "Data ubezpieczenia do",
            "DATE_RANGE": "Zakres dat",
            "ESTATE_DATA": "Dane nieruchomości",
            "ESTATE_TYPE": "Typ nieruchomości",
            "ADDITIONAL_ESTATE_PROPERTIES": "Dodatkowe cechy nieruchomości",
            "IS_RENTED": "Nieruchomość jest przedmiotem najmu",
            "HAS_SAFE_DOOR": "Drzwi o zwiększonej odporności na włamanie (potwierdzone atestem)",
            "HAS_ALARM": "Aktywowany system antywłamaniowy wywołujący alarm",
            "IS_UNDER_PROTECTION": "Stały nadzór wykonywany przez agencję ochrony mienia/prywatnego strażnika, osiedle strzeżone",
            "INSURANCE_COVERAGE": "Zakres ubezpieczenia",
            "FIRE_RANDOM_EVENTS": "Ogień i zdarzenia losowe - All Risk",
            "THEFT": "Kradzież - All Risk",
            "PREMIUM": "Składka",
            "CLIENTS": "Klienci",
            "WELTH": "Majątek",
            "WELTH_POLICY": "Majątek - polisa nr {{number}}",
            "COMMUNICATION": "Komunikacja",
            "COMMUNICATION_POLICY": "Komunikacja - polisa nr {{number}}",
            "FRONTIER": "OC graniczne",
            "FRONTIER_POLICY": "OC graniczne - polisa nr {{number}}",
            "APARTMENT": "Mieszkanie",
            "OUTBUILDING_GARAGES": "Budynki gospodarcze / garaże",
            "EQUIPMENT": "Wyposażenie",
            "PERSONAL_THINGS": "Rzeczy osobiste",
            "GARDEN_ARCHITECTURE": "Architektura ogrodu",
            "FLOOD_RISK": "Ryzyko powodzi",
            "OC_PERSONAL": "OC w życiu prywatnym",
            "INSURED_NUMBER": "Liczba osób Ubezpieczonych",
            "HOME_ASSISTANCE": "Home Assistance",
            "PAYMENTS": "Płatności",
            "INSTALLMENTS_DEFERMENT": "Liczba rat / Odroczenie raty",
            "INSTALLMENTS": "Liczba rat",
            "DEFERMENT": "Odroczenie",
            "DATE_OF_PAYMENT": "Data płatności",
            "AMOUNT_OF_INSTALLMENT": "Wysokość raty",
            "TOTAL_PREMIUM": "Łączna składka",
            "INSURANCE_SCOPE_HOUSE": "Dom",
            "INSURANCE_SCOPE_FLAT": "Mieszkanie"
        },
        "CALCULATION_TYPE": "Rodzaj",
        "BRANCH": "Przedstawicielstwo",
        "AGENCY": "Agencja",
        "OFWCA": "OFWCA",
        "PRODUCT": {
            "CONFIGURE_PROPERTY_AGAIN": "Z powodu zmian na ofercie należy jeszcze raz skonfigurować majątkowy",
            "CONFIGURE_MOTOR_AGAIN": "Z powodu zmian na ofercie należy jeszcze raz skonfigurować produkt komunikacyjny"
        },
        "TOOLTIP": {
            "DELETE_PRODUCT": "Usuń produkt",
            "EDIT_PRODUCT": "Edytuj produkt",
            "EDIT_POLICYHOLDER": "Edytuj Ubezpieczającego",
            "DELETE_INSURED": "Usuń Ubezpieczonego",
            "EDIT_INSURED": "Edytuj Ubezpieczonego",
            "EDIT_PREMIUM": "Edytuj składkę"
        },
        "MODAL": {
            "DELETE_PRODUCT_CONFIRMATION": "Czy na pewno chcesz usunąć produkt?",
            "DELETE_CONTACT_DATA": "Czy na pewno chcesz usunąć dane kontaktowe?",
            "DELETE_INSURED_CONFIRMATION": "Czy na pewno chcesz usunąć Ubezpieczonego z oferty?",
            "CHANGE_CHARACTER_CONFIRMATION": "Czy na pewno chcesz zmienić charakter na {{name}}?",
            "DELETE_CESSION_CONFIRMATION": "Czy na pewno chcesz usunąć cesję?",
            "SEND_OFFER": "Czy na pewno chcesz wysłać klientowi ofertę?",
            "PROVIDE_POLICYHOLDER_CONTACT_DATA": "Podaj email ubezpieczającego, oraz zaznacz wymagane zgody",
            "ASM_TITLE": "Przepraszamy",
            "ASM_MESSAGE": "Żądanie nie może być zrealizowane. <br/> Support ID: <b>{{supportId}}</b>"
        },
        "GROWL": {
            "PRODUCT_DELETED": "Produkt został usunięty",
            "INSURED_DELETED": "Ubezpieczony został usunięty",
            "CESSION_DELETED": "Cesja została usunięta",
            "LANGUAGE_SET": "Język {{lang}} został ustawiony",
            "LANGUAGE_NOT_SET": "Nie ustawiono języka: {{lang}}"
        },
        "REGISTRY": {
            "LIST": "Kartoteka",
            "CONFIGRATIONS_OFFERS": "Kalkulacje i oferty",
            "POLICIES": "Polisy",
            "IOFFER": "iOferta",
            "INSURED": "Ubezpieczający",
            "PREMIUM": "Składka",
            "CALCULATION_TYPE": "Rodzaj",
            "INSURANCE_PERIOD": "Okres ochrony",
            "OFFER_NR_CALCULATION": "Numer",
            "AGENT": "Agent",
            "OFWCA": "OFWCA",
            "POLICY_NUMBER": "Numer polisy",
            "SIGNING_FROM": "Data zawarcia od",
            "SIGNING_TO": "Data zawarcia do",
            "INSURANCE_FROM": "Ochrona od",
            "INSURANCE_TO": "Ochrona do"
        },
        "OFFER_CALCULATION_NUMBER": "Numer oferty / kalkulacji",
        "OFFER": {
            "HEADER": "Oferta nr {{number}}",
            "INFO_BOX": "Oferta jest wiążąca i została zablokowana do edycji. Jej warunki obowiązują do końca dnia. W celu naniesienia zmian cofnij ofertę do edycji.",
            "INFO_BOX_2": "Uwaga – powrót do edycji powoduje ponowną taryfikację składki",
            "BACK_TO_CALCULATION": "Edytuj ofertę",
            "BACK_TO_CALCULATION_CONFIRMATION": "Czy na pewno chcesz przywrócić status kalkulacji?",
            "ACCEPT_OFFER": "Zatwierdź",
            "REJECT_OFFER": "Odrzuć",
            "EMPTY": "Brak wyników spełniających podane kryteria. Zweryfikuj zastosowane filtry."
        },
        "POLICY": {
            "HEADER": "Polisa nr {{number}}",
            "HEADER_MULTIPLE": "Polisy nr {{numbers}}",
            "EMPTY": "Brak wyników spełniających podane kryteria. Zweryfikuj zastosowane filtry."
        },
        "TIMETABLE": {
            "TITLE": "Harmonogram",
            "SUBTITLE": "Administracja działania aplikacji",
            "HEADER": "Harmonogram pracy",
            "ADD_NEW_TERM": "Dodaj nowy termin",
            "TURN_APP_IN": "Włącz aplikację w datach",
            "EXTRA_OPTIONS": "Dodatkowe opcje",
            "TURN_SALES_PATH": "Wyłącz ścieżkę sprzedaży",
            "TURN_OFF_REGISTRY": "Wyłącz kartotekę",
            "DATE_FROM": "Data włączenia",
            "DATE_TO": "Data wyłączenia",
            "REMOVE_DIALOG_TITLE": "Czy jestes pewien?",
            "REMOVE_DIALOG_DESCRIPTION": "Usuwasz wpis z harmonogramu. Czynności nie będzie mozna cofnąć."
        },
        "CONTACT_DATA_DIALOG": {
            "SUBHEADER": "Podanie adresu e-mail i numeru telefonu ułatwi w przyszłości kontakt z klientem"
        },
        "LOCATION_DIALOG": {
            "SUBHEADER": "Miejsce zawarcia umowy"
        },
        "MOTOR_CONFIG": {
            "INSURED_DATA": "Dane ubezpieczonych",
            "INSURED_NAME_PESEL": "Imię i nazwisko / PESEL",
            "DRIVING_LICENSE_DATE": "Data uzyskania prawa jazdy",
            "NO_DRIVING_LICENSE": "Brak prawa jazdy",
            "MOTOR_DATA_EUROTAX": "Dane pojazdu - Eurotax",
            "EUROTAX_CODE": "ID modelu Eurotax",
            "CALCULATE_EUROTAX_VALUE": "Wylicz",
            "MOTOR_TYPE": "Rodzaj pojazdu",
            "MANUFACTURE_YEAR": "Rok produkcji",
            "MAKE": "Marka",
            "MODEL": "Model",
            "BODY_TYPE": "Typ nadwozia",
            "DOOR_NUMBER": "Liczba drzwi",
            "FUEL_TYPE": "Rodzaj paliwa",
            "ENGINE_SIZE": "Pojemność silnika",
            "NOT_IN_EUROTAX": "Pojazd nie widnieje w katalogu Eurotax",
            "VEHICLE_DETAILS": "Cechy szczególne pojazdu",
            "MILEAGE": "Przebieg",
            "FIRST_REGISTRATION_DATE": "Data pierwszej rejestracji",
            "REGISTRATION_NUMBER": "Numer rejestracyjny",
            "VIN": "VIN",
            "MOTOR_VALUE": "Wartość pojazdu (brutto)",
            "UNUSUAL": "Szczególne przeznaczenie pojazdu",
            "RIGHT_STEERING_WHEEL": "Kierownica po prawej stronie",
            "LEASING": "Leasing",
            "IS_IN_LEASING": "Pojazd jest przedmiotem leasingu",
            "LESSER_NAME": "Nazwa leasingodawcy",
            "LESSER_ADDRESS": "Adres leasingodawcy",
            "KW": "Moc",
            "TRANSMISSION": "Skrzynia biegów",
            "TRANSMISSIONS_NUMBER": "Liczba biegów",
            "NUMBER_OF_SEATS": "Liczba miejsc",
            "VERSION": "Wersja",
            "EUROTAX_ID": "Eurotax",
            "PRODUCT_YEARS": "Lata produkcji",
            "MOTOR_DATA_MANUAL": "Dane pojazdu - poza Eurotax",
            "LOAD_CAPACITY": "Ładowność",
            "MAXIMUM_WEIGHT": "Dopuszczalna masa całkowita",
            "CLAIMS_HISTORY": "Historia szkodowości",
            "INSURANCE_COUNTINUITY": "Ciągłość ubezpieczenia w latach",
            "CLAIMS_2YEARS": "Szkody w ostatnich 2 latach",
            "CLAIMS_5YEARS": "Szkody w ostatnich 5 latach",
            "SUM_OF_INSURANCE": "Suma ubezpieczenia",
            "ACCORDING_TO_LAW": "zgodnie z Ustawą",
            "INSURANCE_SCOPE_OC": "OC posiadacza pojazdu",
            "INSURANCE_SCOPE_AC": "AC - utrata i uszkodzenie pojazdu",
            "DAMAGE_LIQUIDATION": "Sposób likwidacji",
            "ADDON_NNW": "NNW kierowcy i pasażerów",
            "ADDON_ASSSTANCE": "Assistance - awaria i wypadek",
            "AUTOCASCO_UNAVAILABLE": "Ubezpieczenie AC nie jest dostępne, ponieważ baza Eurotax nie posiada wyceny dla tego pojazdu. Sprawdź poprawność wprowadzonych danych."
        },
        "FRONTIER_CONFIG": {
            "FRONTIER": "OC graniczne"
        },
        "ASIDE_PARTY": {
            "EDIT_POLICYHOLDER": "Edycja Ubezpieczającego",
            "EDIT_INSURED": "Edycja Ubezpieczonego",
            "ADD_INSURED": "Nowy Ubezpieczony"
        },
        "CLIENTS": {
            "HEADER": "Klienci"
        },
        "MOTOR_MAKE_MODEL": "Marka i model",
        "INSURANCE_PERIOD": "Okres ochrony",
        "INSURANCE_SCOPE": "Zakres ubezpieczenia",
        "CONFIGURE": "Uzupełnij dane",
        "PREVIEW": "Podgląd",
        "CLIENT_DECLARATIONS_CONDITIONS": "Klauzule i oświadczenia klienta",
        "CLIENT_DECLARATION_INFO": "Oświadczenie o administrowaniu danymi przez STU ERGO Hestia S.A., ich przetwarzaniu, możliwości wglądu i aktualizacji danych przez Klienta oraz prawie STU ERGO Hestia do dostępu do danych zgromadzonych w UFG.",
        "CLIENT_DECLARATION_1": "Oświadczam, że zapoznałem/ -łam się z treścią klauzuli informacyjnej administratora",
        "CLIENT_DECLARATION_2": "Oświadczam, że zostało mi okazane i zapoznałem/ -łam się z treścią pełnomocnictwa do zawarcia umowy ubezpieczenia w imieniu STU ERGO Hestia S.A. w Sopocie; przed zawarciem umowy otrzymałem Ogólne Warunki Ubezpieczeń wraz z załącznikami, na podstawie których umowę zawarto oraz zapoznałem się z nimi i zaakceptowałem ich treść; dane we wniosku elektronicznym są zgodne z prawdą i podane zostały według mojej najlepszej wiedzy.",
        "AGENT_DECLARATIONS": "Oświadczenia agenta",
        "SELECT_ALL_DECLARATIONS": "Zaznacz wszystkie oświadczenia agenta",
        "AGENT_DECLARATION_INFO": "Oświadczam, że przed zawarciem umowy ubezpieczenia:",
        "AGENT_DECLARATION_1": "przeprowadzam badanie potrzeb oraz wymagań ubezpieczeniowych Klienta,",
        "AGENT_DECLARATION_2": "przekazałem Klientowi wymagane ustawowo informacje o dystrybutorze,",
        "AGENT_DECLARATION_3": "przekazałem Klientowi ustandaryzowany dokument, zawierający wymagane ustawowo obiektywne informacje o proponowanym produkcie ubezpieczeniowym.",
        "READ_MORE": "Czytaj więcej...",
        "DISTRIBUTOR_DECLARATIONS": "Oświadczenia dotyczące dystrybucji",
        "DISTRIBUTOR_DECLARATION_INFO": "Oświadczam, że w systemie bezpośredniej sprzedaży na odległość, przed zawarciem umowy ubezpieczenia, nastąpiło:",
        "DISTRIBUTOR_DECLARATION_1": "zbadanie i określenie moich wymagań oraz potrzeb ubezpieczeniowych,",
        "DISTRIBUTOR_DECLARATION_2": "przekazanie mi wymaganych ustawowo informacji o dystrybutorze,",
        "DISTRIBUTOR_DECLARATION_3": "przekazanie mi w zrozumiałej formie, jako ustandaryzowany dokument, wymaganych ustawowo obiektywnych informacji o proponowanym produkcie ubezpieczeniowym.",
        "CLIENT_CONDITIONS": "Zgody",
        "CLIENT_CONDITION_1": "Zgoda na otrzymywanie drogą elektroniczną informacji handlowej",
        "CLIENT_CONDITION_1_EXTENDED": "Zgoda na otrzymywanie informacji handlowych drogą elektroniczną. Brak zaznaczenia okienka zgody jest równoznaczne z niewyrażeniem zgody.\n\nZgadzam się na otrzymywanie informacji handlowej od Sopockiego Towarzystwa Ubezpieczeń ERGO Hestia SA w Sopocie, z wykorzystaniem środków porozumiewania się na odległość (telefon, e-mail, indywidualne konto internetowe udostępnione przez Ubezpieczyciela) przy użyciu podanych przeze mnie danych kontaktowych.",
        "CLIENT_CONDITION_2": "Zgoda na otrzymywanie drogą elektroniczną informacji obsługowych",
        "CLIENT_CONDITION_2_EXTENDED": "Zgoda na otrzymywanie drogą elektroniczną informacji obsługowych (zawieranie/obejmowanie ochroną i wykonanie umowy ubezpieczenia) STU ERGO Hestia SA. Brak zaznaczenia okienka zgody jest równoznaczne z niewyrażeniem zgody. Od wyrażenia zgody na poniższe nie uzależnia się zawarcia umowy ubezpieczenia/objęcia ochroną ubezpieczeniową (jeżeli dotyczy).\n\nWnioskuję o przesyłanie przez Sopockie Towarzystwo Ubezpieczeń ERGO Hestia SA w Sopocie korespondencji związanej z wykonywaniem wszystkich czynności ubezpieczeniowych za pomocą środków porozumiewania się na odległość (telefon, e-mail, indywidualne konto internetowe udostępnione przez Ubezpieczyciela) na podane przeze mnie dane kontaktowe, a odpowiedzi na złożone reklamacje na wskazany w danych adres e-mail. Zobowiązuję się do aktualizacji danych.",
        "CLIENT_CONDITION_3": "Wyrażam zgodę na zawarcie umowy ubezpieczenia na warunkach wskazanych w ofercie przekazanej mi z wykorzystaniem środków porozumiewania się na odległość.",
        "PASSWORD": "Hasło",
        "LOG_IN": "Zaloguj się",
        "INFO": {
            "USE_YOUR_CREDENTIALS": "Użyj dotychczasowych danych do logowania w systemie sprzedażowym",
            "ADD_CONTACT_DATA": "Podanie adresu e-mail i numeru telefonu ułatwi w przyszłości kontakt z klientem",
            "OFFER_SAVED": "Oferta zapisana"
        },
        "CLIENT_DATA": "Dane klientów",
        "POLICYHOLDER": "Ubezpieczający",
        "NAME_SURNAME_FAMILYNAME": "Imię / nazwisko / nazwisko rodowe",
        "PESEL": "PESEL",
        "NO_PESEL": "Brak nr PESEL - obcokrajowiec",
        "NATIONALITY": "Obywatelstwo",
        "BIRTH_DATE": "Data urodzenia",
        "DOCUMENT_TYPE": "Typ dokumentu",
        "DOCUMENT_NUMBER": "Nr dokumentu",
        "RESIDENTIAL_ADDRESS": "Adres zamieszkania",
        "POSTAL_CODE": "kod pocztowy",
        "CITY": "miejscowość",
        "STREET": "ulica",
        "AVENUE": "aleja",
        "SQUARE": "plac",
        "HOUSE_NUMBER": "nr domu",
        "HOUSE_UNIT_NUMBER": "nr lokalu",
        "OTHER_MAIL_DROP": "Inny adres do korespondencji",
        "POLICYHOLDER_IS_INSURED": "Ubezpieczający jest jednocześnie ubezpieczonym",
        "OFFER_CALCULATION": "Kalkulacja oferty",
        "INSURED": "Ubezpieczony",
        "DIALOG": {
            "DELETE_CLIENT": "Czy na pewno chcesz usunąć tego klienta?",
            "DELETE_CALCULATION": "Czy jesteś pewien, że chcesz usunąć konfigurację?",
            "ACCEPT_OFFER": "Czy na pewno chcesz zaakceptować ofertę?",
            "REJECT_OFFER": "Czy na pewno chcesz odrzucić ofertę?"
        },
        "CLIENT": "Klient",
        "POLICYHOLDER_DATA": "Dane Ubezpieczającego",
        "INSURED_DATA": "Dane Ubezpieczonego",
        "ASSETS": "Majątek",
        "PAYMENTS": "Płatności",
        "FULL_INSURANCE_PREMIUM": "Łączna składka",
        "PROPERTY_TYPE": "Typ nieruchomości",
        "PROPERTY_ADDRESS": "Adres nieruchomości",
        "INSTALLMENT_NUMBER": "Liczba rat",
        "INSTALLMENT_AMOUNT": "Wysokość raty",
        "CALCULATION_SUBJECT": {
            "NEW_POLICY": "Nowa polisa",
            "CONTINUATION": "Kontynuacja polisy"
        },
        "RISK_HOME_ASSISTANCE": "Home assistance",
        "SUM_INSURED_200000": "200 000 zł",
        "INSTALLMENT_POSTPONEMENT": "Odroczenie raty",
        "NAME_SURNAME_COMPANY": "Imię i nazwisko / nazwa",
        "CALCULATION_SUMMARY": "Podsumowanie kalkulacji",
        "CONTRACT_DATE_PLACE": "Data i miejsce zawarcia umowy",
        "POLICYHOLDER_CONTACT_DATA": "Dane kontaktowe Ubezpieczającego",
        "CONTACT_DATA": "Dane kontaktowe",
        "CESSIONARY_DATA": "Dane cesjonariusza",
        "CESSIONARY_TYPE": "Rodzaj cesjonariusza",
        "CESSIONARY_NAME": "Nazwa ",
        "ORIGIN_COUNTRY": "Kraj pochodzenia",
        "ADDRESS": "Adres",
        "POLICY_DATE_AND_CITY": "Data, miejscowość",
        "INSURED_OBJECT": "Przedmiot",
        "POLICY_DIALOG": {
            "HEADER": "Informacja"
        },
        "CONFIRMATION": {
            "ISSUE_POLICY_FROM_CALCULATION": "Potwierdź poprawność uzupełnionych danych. Po zatwierdzeniu polisy nie ma możliwości powrotu do edycji.",
            "ISSUE_POLICY_FROM_OFFER": "Czy na pewno chcesz zatwierdzić tą ofertę?"
        },
        "SCHEDULE": {
            "DATES": "Zakres dat",
            "AUTHOR": "Autor",
            "OPERATIONS": "Operacje",
            "TOOLTIP": {
                "EDIT_ENTRY": "edytuj wpis",
                "DELETE_ENTRY": "usuń wpis"
            },
            "ENTRY_DELETED": "Usunięto wpis",
            "ENTRY_ADDED": "Dodano wpis",
            "ENTRY_EDITED": "Edytowano wpis",
            "SALE_IS_NOT_ACTIVE": "Moduł sprzedaży zapasowej (komunikacja/majątek) jest obecnie wyłączony.",
            "APPLICATION_IS_NOT_ACTIVE": "Moduł sprzedaży zapasowej (komunikacja/majątek) jest obecnie wyłączony. Dokument jest dostępny tylko w trybie do odczytu."
        },
        "CLIENT_OFFER": {
            "YOUR_POLICY": "Twoja polisa",
            "THANKS_FOR_PURCHASE": "Dziękujemy za zakup polisy. Dokumenty zostały wysłane na podany adres email.",
            "OFFER_REJECTED": "Oferta została odrzucona",
            "CONTACT_AGENT_FOR_NEW_OFFER": "W celu wygenerowania nowej oferty skontaktuj się ze swoim Agentem"
        },
        "IOFFER": {
            "VERIFICATION": {
                "TITLE": "Twoja oferta",
                "SUBTITLE": "Podaj swój PESEL, aby uzyskać dostęp do oferty. W kolejnym kroku będzie możliwość akceptacji oferty, opłacenia i wydruku polisy.",
                "SUBTITLE2": "Warunki oferty ważne są do końca dnia.",
                "ERROR": {
                    "WRONG_PESEL": "Podany PESEL jest nieprawidłowy"
                },
                "GO_TO_OFFER": "Przejdź do oferty"
            },
            "OFFER": {
                "OFFER_NUMBER": "Oferta nr {{number}}"
            },
            "CLAUSES": {
                "INFO": {
                    "CHECKBOX_NOT_CHECKED": "Podczas rozmowy Agent zaznaczył poniższe klauzule, oświadczenia i zgody, które są wymagane do zawarcia umowy ubezpieczenia na odległość.<br>\nJeżeli nie wyrażasz na nie zgody lub nie potwierdzasz Oświadczeń Agenta, odrzuć ofertę i skontaktuj się ponownie z Doradcą Ubezpieczeniowym.<br>\nAkceptacja jest jednoznaczna z wyrażeniem zgody na zawarcie umowy ubezpieczenia na warunkach wskazanych w ofercie przekazanej z wykorzystaniem środków porozumiewania się na odległość."
                }
            },
            "CHECK_DATA_INFO": "Sprawdź zakres i sumy ubezpieczenia pobierając dokument Wydruk oferty.",
            "REJECTED": {
                "TITLE": "Oferta została odrzucona",
                "SUB_TITLE": "W celu wygnenerowania nowej oferty skontaktuj się ze swoim Agentem."
            },
            "RETURN": {
                "TITLE": "Dziękujemy!",
                "PENDING": "Twoja płatność jest przetwarzana. Wciąż czekamy na informację na temat statusu transakcji.",
                "PAID": "Twoja płatność zakończyła się sukcesem",
                "FAILURE": "Twoja płatność nie powiodła się. Na podany przez Ciebie adres wysłaliśmy e-mail z linkiem, umożliwiającym ponowną realizacje transakcji."
            },
            "EXPIRED": {
                "TITLE": "Link wygasł",
                "SUB_TITLE": "Link do oferty wygasł.",
                "SUB_TITLE2": "Skonsultuj się z Agentem, aby wygenerować nową ofertę."
            },
            "ACCEPTED": {
                "TITLE": "Oferta została zaakceptowana",
                "SUB_TITLE": "Dziękujemy za zakup polisy.",
                "SUB_TITLE2": "Dokumenty zostały wysłane na podany adress e-mail."
            },
            "BROKEN_LINK": {
                "TITLE": "Nieprawidłowy link",
                "SUB_TITLE": "Link do oferty jest nieprawidłowy.",
                "SUB_TITLE2": "Skontaktuj się z Agentem, aby wygenerować nowy link."
            },
            "POLICY": {
                "TITLE": "Twoja polisa nr {{number}}",
                "TITLE_MULTIPLE": "Twoje polisy nr {{numbers}}"
            },
            "PRINTOUT": {
                "ONLY_FROM_AGENT": "Dokument dostępny u agenta"
            }
        },
        "SUMMARY": {
            "CITY_INFO_BOX": "Dodanie miejscowości w której została zawarta oferta jest wymagane"
        }
    },
    "en": {
        "LOGIN": {
            "USERNAME": "Login",
            "PASSWORD": "Password",
            "LOGIN_REQUIRED_INFO": "Enter registered login",
            "SEND_PASSWORD_HEADER": "Reset password",
            "RECOVER_HEADER": "E-mail has been sent",
            "BUTTON": {
                "LOGIN": "Login"
            },
            "LOG_IN": "Log in",
            "APP_NAME": "EH24",
            "APP_NAME_ALTERNATIVE": "Intermediary portal",
            "APP_SUBNAME": "Support application",
            "INFORMATION": "Use your existing login details to the sales system. If your password is not working and it has been changed in the last week, enter the previous one.",
            "INVALID_CREDENTIALS": "Invalid credentials"
        },
        "LABEL": {
            "PASSWORD": {
                "RESET_INFORMATION": "Enter your username to reset your password.",
                "RESET_DIALOG": "If the given account exists in the system, a message will be sent to the email assigned to the account with information on how to reset the password.",
                "INFORMATION": "You asked for password change. Set new one. The password should contain at least 8 characters and should contain characters from at least three of the following character groups: <br/>\n<ul>\n<li> lowercase </li>\n<li> uppercase </li>\n<li> numbers </li>\n<li> special characters </li>\n</ul>",
                "NEW_PASSWORD": "New password",
                "NEW_PASSWORD_REPEAT": "Repeat new password",
                "RESET_DIALOG_SUCCESS": "The password has been changed, you will be redirected to login page."
            },
            "FILE_NAME": "Document name",
            "CALCULATION_PRINTOUT": "Calculation printout",
            "OFFER_PRINTOUT": "Offer printout",
            "POLICY_PRINTOUT": "Policy printout",
            "SUMMARY_PRINTOUT": "Summary printout",
            "CERTIFICATE_PRINTOUT": "Certificate printout",
            "PAGINATOR": "{{page}} out of {{pages}}",
            "SELLER": "Seller",
            "ROLE": {
                "AGENT": "Agent",
                "WORKER": "Worker",
                "DIRECT_SALES": "Direct sales",
                "SALES_MANAGER": "Sales manager",
                "HEADQUATERS": "Headquarters"
            },
            "LOGGED_OUT_HEADER": "Information",
            "LOGGED_OUT_DESCRIPTION": "Session has expired",
            "YES": "Yes",
            "NO": "No",
            "PICK": "Choose",
            "NAME": "Name",
            "SURNAME": "Surname",
            "FAMILY_NAME": "Family name",
            "PESEL": "PESEL",
            "NO_PESEL": "No PESEL - foreigner",
            "FOREIGNER": "Foreigner",
            "POLICYHOLDER_INSURED": "Policy holder / insurer",
            "POLICYHOLDER": "Policy holder",
            "INSURED": "Insured",
            "INSURED_NUMBER": "Insured {{index}}",
            "ADDRESS": "Main address",
            "ADDRESS_CORESPONDENCE": "Corespondence address",
            "BOTH_ADDRESSES": "Main / corespondence address",
            "POST_CODE": "Postal code",
            "CITY": "City",
            "STREET_PREFIX": "Prefix",
            "STREET": "Street",
            "STREET_NUMBER": "Street number",
            "DOOR_NUMBER": "Door number",
            "DIFFERENT_CORRESPONDENCE_ADDRESS": "Different correspondence address",
            "INSURER_IS_INSURED": "Policy holder is also insured",
            "PREMIUM": "Premium",
            "NIP": "NIP",
            "REGON": "REGON",
            "GO_TO_CALCULATION": "Go to calculation",
            "CITIZENSHIP": "Citizenship",
            "DATE_OF_BIRTH": "Date of birth",
            "GENDER": "Gender",
            "DOCUMENT_TYPE": "Document type",
            "DOCUMENT_NUMBER": "Document number",
            "SUFFIX_KG": "kg",
            "SUFFIX_PLN": "zł",
            "SUFFIX_KM": "km",
            "SUFFIX_CM3": "cm³",
            "SUFFIX_KW": "kW",
            "CONFIRMATION": "Confirmation",
            "POLICY_NUMBER": "Policy number",
            "OC": "TPL",
            "AC": "AC",
            "SAVE_FAILED": "There are errors on the form",
            "GROWL_SUCCESS_TITLE": "Information",
            "GROWL_ERROR_TITLE": "An error has occured",
            "SELECT_FILTER": "Filter...",
            "SELECT_PLACEHOLDER": "-",
            "SUBMIT_CALCULATION": "Submit",
            "GENERATE_OFFER": "Generate offer",
            "PHONE_NUMBER": "Phone number",
            "EMAIL": "e-mail",
            "LOCATION_CHANGE_TITLE": "Location definition",
            "CREATION_DATE": "Creation date",
            "CREATION_DATE_FROM": "Creation date from",
            "CREATION_DATE_TO": "Creation date to",
            "FRONTIER_HEADER": "Frontier TPL",
            "POLICYHOLDER_AND_INSURED": "Policyholder / insured",
            "GO_TO_SUMMARY": "Go to summary",
            "PHONE_PREFIX": "Prefix",
            "VEHICLE_ORIGIN_COUNTRY": "Vehicle origin country",
            "COUNTRY": "Country",
            "PARTY_TYPE": "Party type",
            "COMPANY_NAME": "Company name",
            "COMPANY_NUMBER": "Company number",
            "COMPANY_COUNTRY": "Company country",
            "INSURANCE_PERIOD": "Insurance period",
            "PAYMENT": "Payment",
            "PAYMENT_TYPE": "Payment type",
            "PAYMENT_TYPE_HEADER1": "Preferred payment method - cash.",
            "PAYMENT_TYPE_HEADER2": "The bank transfer payment option should only be chosen when cash is not available."
        },
        "ERROR": {
            "403": "Access denied",
            "500": "Internal server error",
            "PASSWORD_CHANGE_FAILURE": "Password change failure",
            "TIMEOUT": "Timeout has occured",
            "FAILED_ROUTING_HEADER": "Navigation failure",
            "FAILED_ROUTING_DESCRIPTION": "Could not go to {{url}}. You have been redirected to the home page.",
            "PAYMENT_FAILED": "Payment could not be started."
        },
        "DASHBOARD": {
            "HEADER": "Dashboard",
            "NEW_OFFER": "New offer",
            "NEW_OFFER_SUB": "Property, Motor",
            "NEW_FRONTIER_SUB": "Frontier TPL",
            "REGISTRY": "Registry",
            "REGISTRY_SUB": "Calculations, offers and policies"
        },
        "HEADER": {
            "OPEN_MENU": "Open menu"
        },
        "BUTTON": {
            "BACK": "Back",
            "CHANGE": "Change",
            "SAVE": "Save",
            "CALCULATE": "Calculate",
            "CONFIRM": "Confirm",
            "CLOSE": "Close",
            "OK": "OK",
            "CANCEL": "Cancel",
            "SEARCH": "Search",
            "EXPORT_CSV": "Export to CSV",
            "ADD_INSURED": "Add Insured",
            "REMOVE_INSURED": "Remove Insured",
            "DOWNLOAD_ALL": "Download all",
            "GO_TO_CALCULATION": "Go to calculation",
            "GO_TO_SUMMARY": "Go to summary",
            "NEXT": "Next",
            "ADD_CONTACT_DATA": "Add contact data",
            "EDIT_CONTACT_DATA": "Edit contact data",
            "DELETE_CONTACT_DATA": "Delete contact data",
            "ADD_CESSION": "Add cession",
            "EDIT_CESSION": "Edit cession",
            "DELETE_CESSION": "Delete cession",
            "ACCEPT_OFFER": "Accept offer",
            "SEND_OFFER": "Send offer to e-mail",
            "GO_TO_OFFER": "Go to offer",
            "PAY": "Pay",
            "PAYMENT_PENDING": "Payment in progress",
            "PAYMENT_SUCCESS": "Payment success"
        },
        "OFFER_CONFIG": {
            "NEW_OFFER": "New offer",
            "HEADER": "Offer configuration",
            "POLICY_DATA": "Policy data",
            "TYPE_OF_POLICY": "Type of policy",
            "LAST_YEAR_POLICY_NR": "Last year policy number",
            "PROTECTION_PERIOD": "Protection period",
            "INSURANCE_DATE_FROM": "Insurance date from",
            "INSURANCE_DATE_TO": "Insurance date to",
            "DATE_RANGE": "Date range",
            "ESTATE_DATA": "Estate data",
            "ESTATE_TYPE": "Estate type",
            "ADDITIONAL_ESTATE_PROPERTIES": "Additional estate properties",
            "IS_RENTED": "Estate is beeing rent",
            "HAS_SAFE_DOOR": "Extra protection doors",
            "HAS_ALARM": "Anti burglar alarm",
            "IS_UNDER_PROTECTION": "Permanent supervision",
            "INSURANCE_COVERAGE": "Insurance coverage",
            "FIRE_RANDOM_EVENTS": "Fire and random events - All Risk",
            "THEFT": "Theft - All Risk",
            "PREMIUM": "Premium",
            "CLIENTS": "Clients",
            "WELTH": "Property",
            "WELTH_POLICY": "Property - policy {{number}}",
            "COMMUNICATION": "Motor",
            "COMMUNICATION_POLICY": "Motor - policy {{number}}",
            "FRONTIER": "Frontier",
            "FRONTIER_POLICY": "Frontier - policy {{number}}",
            "APARTMENT": "Apartment",
            "OUTBUILDING_GARAGES": "Outbuildings/ garages",
            "EQUIPMENT": "Equipment",
            "PERSONAL_THINGS": "Personal things",
            "GARDEN_ARCHITECTURE": "Garden architecture",
            "FLOOD_RISK": "Flood risk",
            "OC_PERSONAL": "Personal liability",
            "INSURED_NUMBER": "Number of insured persons",
            "HOME_ASSISTANCE": "Home Assistance",
            "PAYMENTS": "Payments",
            "INSTALLMENTS_DEFERMENT": "Number of installments / installment deferment",
            "INSTALLMENTS": "Number of installments",
            "DEFERMENT": "Installment deferment",
            "DATE_OF_PAYMENT": "Date of payment",
            "AMOUNT_OF_INSTALLMENT": "Amount of installment",
            "TOTAL_PREMIUM": "Total premium",
            "INSURANCE_SCOPE_HOUSE": "House",
            "INSURANCE_SCOPE_FLAT": "Flat"
        },
        "CALCULATION_TYPE": "Type",
        "BRANCH": "Branch",
        "AGENCY": "Agency",
        "OFWCA": "OFWCA",
        "PRODUCT": {
            "CONFIGURE_PROPERTY_AGAIN": "Please configure property product again",
            "CONFIGURE_MOTOR_AGAIN": "Please configure motor product again"
        },
        "TOOLTIP": {
            "DELETE_PRODUCT": "Delete product",
            "EDIT_PRODUCT": "Edit product",
            "EDIT_POLICYHOLDER": "Edit policyholder",
            "DELETE_INSURED": "Delete insured",
            "EDIT_INSURED": "Edit insured",
            "EDIT_PREMIUM": "Edit premium"
        },
        "MODAL": {
            "DELETE_PRODUCT_CONFIRMATION": "Do you want to delete product?",
            "DELETE_CONTACT_DATA": "Do you want to delete contact data?",
            "DELETE_INSURED_CONFIRMATION": "Do you want to delete insured?",
            "CHANGE_CHARACTER_CONFIRMATION": "Are you sure you want to change character to {{name}}?",
            "DELETE_CESSION_CONFIRMATION": "Are you sure you want to delete cession?",
            "SEND_OFFER": "Are you sure you want to send the client an offer?",
            "PROVIDE_POLICYHOLDER_CONTACT_DATA": "Enter the insured person's email and select the required consents",
            "ASM_TITLE": "We are sorry",
            "ASM_MESSAGE": "The request could not be processed. <br/> Support ID: <b> {{supportId}} </b>"
        },
        "GROWL": {
            "PRODUCT_DELETED": "Product was deleted",
            "INSURED_DELETED": "Insured was deleted",
            "CESSION_DELETED": "Cession has been deleted",
            "LANGUAGE_SET": "The language {{lang}} has been set",
            "LANGUAGE_NOT_SET": "Language not set: {{lang}}"
        },
        "REGISTRY": {
            "LIST": "Registry - offer and calculations",
            "CONFIGRATIONS_OFFERS": "Configuration and offer list",
            "POLICIES": "Policy list",
            "IOFFER": "iOffer",
            "INSURED": "Insured",
            "PREMIUM": "Premium",
            "CALCULATION_TYPE": "Type",
            "INSURANCE_PERIOD": "Insurance period",
            "OFFER_NR_CALCULATION": "Offer number/ Calculation",
            "AGENT": "Agent",
            "OFWCA": "OFWCA",
            "POLICY_NUMBER": "Policy number",
            "SIGNING_FROM": "Signing from",
            "SIGNING_TO": "Signing to",
            "INSURANCE_FROM": "Insurance from",
            "INSURANCE_TO": "Insurance to"
        },
        "OFFER_CALCULATION_NUMBER": "Offer / calculation number",
        "OFFER": {
            "HEADER": "Offer {{number}}",
            "INFO_BOX": "The offer is binding and has been blocked for editing. Its terms are valid until the end of the day. In order to make changes, withdraw the offer for editing.",
            "INFO_BOX_2": "Warning - returning to the offer edit will result in the re-pricing of the premium",
            "BACK_TO_CALCULATION": "Edit offer",
            "BACK_TO_CALCULATION_CONFIRMATION": "Are you sure you want to restore the calculation status?",
            "ACCEPT_OFFER": "Accept",
            "REJECT_OFFER": "Reject",
            "EMPTY": "There are no results that match your criteria. Check if the data you provided is correct."
        },
        "POLICY": {
            "HEADER": "Policy {{number}}",
            "HEADER_MULTIPLE": "Policies {{numbers}}",
            "EMPTY": "There are no results that match your criteria. Check if the data you provided is correct."
        },
        "TIMETABLE": {
            "TITLE": "Timetable",
            "SUBTITLE": "Timetable administration",
            "HEADER": "Work timetable",
            "ADD_NEW_TERM": "Add new term",
            "TURN_APP_IN": "Turn on app on folowing days",
            "EXTRA_OPTIONS": "Extra options",
            "TURN_SALES_PATH": "Turn off sales path",
            "TURN_OFF_REGISTRY": "Turn off registry",
            "DATE_FROM": "Start date",
            "DATE_TO": "End date",
            "REMOVE_DIALOG_TITLE": "Are you sure?",
            "REMOVE_DIALOG_DESCRIPTION": "You are trying to delete timetable item."
        },
        "CONTACT_DATA_DIALOG": {
            "SUBHEADER": "It will be easier for us to contact you when you give us e-mail and phone number."
        },
        "LOCATION_DIALOG": {
            "SUBHEADER": "Place of conclusion of the contract"
        },
        "MOTOR_CONFIG": {
            "INSURED_DATA": "Insured data",
            "INSURED_NAME_PESEL": "Given name, surname / PESEL",
            "DRIVING_LICENSE_DATE": "Driving license issue date",
            "NO_DRIVING_LICENSE": "No driving license",
            "MOTOR_DATA_EUROTAX": "Vehicle data - Eurotax",
            "EUROTAX_CODE": "Eurotax ID",
            "CALCULATE_EUROTAX_VALUE": "Calculate",
            "MOTOR_TYPE": "Motor type",
            "MANUFACTURE_YEAR": "Manufacture year",
            "MAKE": "Make",
            "MODEL": "Model",
            "BODY_TYPE": "Body type",
            "DOOR_NUMBER": "Number of doors",
            "FUEL_TYPE": "Fuel type",
            "ENGINE_SIZE": "Engine capacity",
            "NOT_IN_EUROTAX": "The vehicle is not listed in the Eurotax catalog",
            "VEHICLE_DETAILS": "Vehicle details",
            "MILEAGE": "Mileage",
            "FIRST_REGISTRATION_DATE": "Date of first registration",
            "REGISTRATION_NUMBER": "Registration number",
            "VIN": "VIN",
            "MOTOR_VALUE": "Vehicle value (gross)",
            "UNUSUAL": "Unusual usage",
            "RIGHT_STEERING_WHEEL": "Right hand drive",
            "LEASING": "Leasing",
            "IS_IN_LEASING": "Vehicle is in leasing",
            "LESSER_NAME": "Lessor's name",
            "LESSER_ADDRESS": "Lessor's address",
            "KW": "Power",
            "TRANSMISSION": "Transmission",
            "TRANSMISSIONS_NUMBER": "Number of gears",
            "NUMBER_OF_SEATS": "Number of seats",
            "VERSION": "Version",
            "EUROTAX_ID": "Eurotax",
            "PRODUCT_YEARS": "MOTOR_CONFIG.PRODUCT_YEARS",
            "MOTOR_DATA_MANUAL": "Vehicle data - manual entry",
            "LOAD_CAPACITY": "Load capacity",
            "MAXIMUM_WEIGHT": "Maximum weight",
            "CLAIMS_HISTORY": "Claims history",
            "INSURANCE_COUNTINUITY": "Continuity of insurance in years",
            "CLAIMS_2YEARS": "Claims during last 2 years",
            "CLAIMS_5YEARS": "Claims during last 5 years",
            "SUM_OF_INSURANCE": "Sum of insurance",
            "ACCORDING_TO_LAW": "According to Law",
            "INSURANCE_SCOPE_OC": "TPL of vehicle owner",
            "INSURANCE_SCOPE_AC": "AC - loss and damage to the vehicle",
            "DAMAGE_LIQUIDATION": "Method of liquidation",
            "ADDON_NNW": "Personal accident insurance",
            "ADDON_ASSSTANCE": "Assistance - failure and accident",
            "AUTOCASCO_UNAVAILABLE": "AC insurance is not available as the Eurotax database does not have a valuation for this vehicle. Check the correctness of the entered data."
        },
        "FRONTIER_CONFIG": {
            "FRONTIER": "Border liability insurance"
        },
        "ASIDE_PARTY": {
            "EDIT_POLICYHOLDER": "Edit policyholder",
            "EDIT_INSURED": "Edit insured",
            "ADD_INSURED": "New insured"
        },
        "CLIENTS": {
            "HEADER": "Clients"
        },
        "MOTOR_MAKE_MODEL": "Brand and model",
        "INSURANCE_PERIOD": "Insurance period",
        "INSURANCE_SCOPE": "Scope of Insurance",
        "CONFIGURE": "Configure",
        "PREVIEW": "Preview",
        "CLIENT_DECLARATIONS_CONDITIONS": "Clauses and customer statements",
        "CLIENT_DECLARATION_INFO": "Statement on data administration by STU ERGO Hestia S.A., their processing, the possibility of viewing and updating the data by the Client and the right of STU ERGO Hestia to access data collected in UFG.",
        "CLIENT_DECLARATION_1": "I declare that I have read the content of the administrator's information clause",
        "CLIENT_DECLARATION_2": "I declare that I have been presented and that I have read the content of the power of attorney to conclude an insurance contract on behalf of STU ERGO Hestia S.A. in Sopot; before concluding the contract, I received the General Terms and Conditions of Insurance with attachments on the basis of which the contract was concluded and I have read and accepted their content; the data in the electronic application are true and were given to the best of my knowledge.",
        "AGENT_DECLARATIONS": "Agent statements",
        "SELECT_ALL_DECLARATIONS": "Select all agent claims",
        "AGENT_DECLARATION_INFO": "I declare that before concluding the insurance contract:",
        "AGENT_DECLARATION_1": "I conduct a study of the client's needs and insurance requirements,",
        "AGENT_DECLARATION_2": "I have provided the customer with the information about the distributor required by law,",
        "AGENT_DECLARATION_3": "I have provided the Client with a standardized document containing the statutory objective information about the proposed insurance product.",
        "READ_MORE": "Read more...",
        "DISTRIBUTOR_DECLARATIONS": "Distribution Statements",
        "DISTRIBUTOR_DECLARATION_INFO": "I declare that in the direct distance selling system, prior to the conclusion of the insurance contract, the following took place:",
        "DISTRIBUTOR_DECLARATION_1": "examining and defining my requirements and insurance needs,",
        "DISTRIBUTOR_DECLARATION_2": "providing me with statutory information about the distributor,",
        "DISTRIBUTOR_DECLARATION_3": "providing me in an understandable form, as a standardized document, with the legally required objective information about the proposed insurance product.",
        "CLIENT_CONDITIONS": "Consent",
        "CLIENT_CONDITION_1": "Consent to receive commercial information by electronic means",
        "CLIENT_CONDITION_1_EXTENDED": "Consent to receive commercial information by electronic means. Not selecting the consent box mean refusing consent.\n\nI agree to receive commercial information from Sopockie Towarzystwo Ubezpieczeń ERGO Hestia SA in Sopot, using means of distance communication (telephone, e-mail, individual internet account provided by the Insurer) using the contact details provided by me.",
        "CLIENT_CONDITION_2": "Consent to receive service information electronically",
        "CLIENT_CONDITION_2_EXTENDED": "Consent to receive service information by electronic means (conclusion / coverage and performance of the insurance contract) of STU ERGO Hestia SA. Not selecting the consent box mean refusing consent. The conclusion of an insurance contract / coverage (if applicable) is not conditional on the consent to the following.\n\nI request that Sopockie Towarzystwo Ubezpieczeń ERGO Hestia SA in Sopot send correspondence related to the performance of all insurance activities by means of distance communication (telephone, e-mail, individual internet account provided by the Insurer) to the contact details provided by me, and replies to submitted complaints to the e-mail address provided in the data. I undertake to update the data.",
        "CLIENT_CONDITION_3": "I consent to the conclusion of the insurance contract on the terms specified in the offer provided to me using means of distance communication.",
        "PASSWORD": "Password",
        "LOG_IN": "Log in",
        "INFO": {
            "USE_YOUR_CREDENTIALS": "Use your existing login details to the sales system",
            "ADD_CONTACT_DATA": "Providing an e-mail address and telephone number will facilitate contact with the customer in the future",
            "OFFER_SAVED": "Offer has been saved"
        },
        "CLIENT_DATA": "Client data",
        "POLICYHOLDER": "Policyholder",
        "NAME_SURNAME_FAMILYNAME": "Given name / Surname / Family name",
        "PESEL": "PESEL ",
        "NO_PESEL": "No PESEL - foreigner",
        "NATIONALITY": "Nationality",
        "BIRTH_DATE": "Birth date",
        "DOCUMENT_TYPE": "Document type",
        "DOCUMENT_NUMBER": "Document number",
        "RESIDENTIAL_ADDRESS": "Residential address",
        "POSTAL_CODE": "postal code",
        "CITY": "city",
        "STREET": "street",
        "AVENUE": "avenue",
        "SQUARE": "square",
        "HOUSE_NUMBER": "house number",
        "HOUSE_UNIT_NUMBER": "apartment number",
        "OTHER_MAIL_DROP": "Other mailing address",
        "POLICYHOLDER_IS_INSURED": "Policyholder is insured",
        "OFFER_CALCULATION": "Offer calculation",
        "INSURED": "Insured",
        "DIALOG": {
            "DELETE_CLIENT": "Are you sure you want to delete this client?",
            "DELETE_CALCULATION": "Are you sure you want to delete the configuration?",
            "ACCEPT_OFFER": "Are you sure you want to accept the offer?",
            "REJECT_OFFER": "Are you sure you want to decline the offer?"
        },
        "CLIENT": "Client",
        "POLICYHOLDER_DATA": "Policyholder data",
        "INSURED_DATA": "Insured data",
        "ASSETS": "Assets",
        "PAYMENTS": "Payment",
        "FULL_INSURANCE_PREMIUM": "Total premium",
        "PROPERTY_TYPE": "Property type",
        "PROPERTY_ADDRESS": "Property address",
        "INSTALLMENT_NUMBER": "Installment number",
        "INSTALLMENT_AMOUNT": "Installment amount",
        "CALCULATION_SUBJECT": {
            "NEW_POLICY": "New policy",
            "CONTINUATION": "Policy continuation"
        },
        "RISK_HOME_ASSISTANCE": "Home assistance",
        "SUM_INSURED_200000": "200 000 zł",
        "INSTALLMENT_POSTPONEMENT": "Installment postponement",
        "NAME_SURNAME_COMPANY": "Given name, surname / company name",
        "CALCULATION_SUMMARY": "Calculation summary",
        "CONTRACT_DATE_PLACE": "Contract date and place",
        "POLICYHOLDER_CONTACT_DATA": "Policyholder contact data",
        "CONTACT_DATA": "Contact data",
        "CESSIONARY_DATA": "Cessionary data",
        "CESSIONARY_TYPE": "Cessionary type",
        "CESSIONARY_NAME": "Cessionary name",
        "ORIGIN_COUNTRY": "Origin country",
        "ADDRESS": "Address",
        "POLICY_DATE_AND_CITY": "Policy date, city",
        "INSURED_OBJECT": "Insured object",
        "POLICY_DIALOG": {
            "HEADER": "Information"
        },
        "CONFIRMATION": {
            "ISSUE_POLICY_FROM_CALCULATION": "Confirm the correctness of the completed data. After approval of the policy, it is not possible to return to the edition.",
            "ISSUE_POLICY_FROM_OFFER": "Are you sure you want to approve this offer?"
        },
        "SCHEDULE": {
            "DATES": "Date range",
            "AUTHOR": "Author",
            "OPERATIONS": "Operations",
            "TOOLTIP": {
                "EDIT_ENTRY": "edit",
                "DELETE_ENTRY": "delete"
            },
            "ENTRY_DELETED": "Entry deleted",
            "ENTRY_ADDED": "Entry added",
            "ENTRY_EDITED": "Entry edited",
            "SALE_IS_NOT_ACTIVE": "The sales module is currently disabled.",
            "APPLICATION_IS_NOT_ACTIVE": "The sales module is currently disabled. The document is available in read-only mode."
        },
        "CLIENT_OFFER": {
            "YOUR_POLICY": "Your policy",
            "THANKS_FOR_PURCHASE": "Thank you for purchasing the policy. The documents have been sent to the e-mail address provided.",
            "OFFER_REJECTED": "The offer was rejected",
            "CONTACT_AGENT_FOR_NEW_OFFER": "In order to generate a new offer, please contact your Agent"
        },
        "IOFFER": {
            "VERIFICATION": {
                "TITLE": "Your offer",
                "SUBTITLE": "Enter your PESEL number to access the offer. In the next step, you will be able to accept the offer, pay for and print the policy.",
                "SUBTITLE2": "The terms of the offer are valid until the end of the day.",
                "ERROR": {
                    "WRONG_PESEL": "Provided PESEL is not valid"
                },
                "GO_TO_OFFER": "Go to offer"
            },
            "OFFER": {
                "OFFER_NUMBER": "Offer {{number}}"
            },
            "CLAUSES": {
                "INFO": {
                    "CHECKBOX_NOT_CHECKED": "During the conversation, the Agent marked the following clauses, declarations and consents that are required to conclude a distance insurance contract. <br>\nIf you do not agree to them or do not confirm the Agent's Declarations, reject the offer and contact the Insurance Advisor again. <br>\nAcceptance is tantamount to consent to the conclusion of the insurance contract on the terms specified in the offer provided using means of distance communication."
                }
            },
            "CHECK_DATA_INFO": "Check scope and insurance sum by downloading offer printout document.",
            "REJECTED": {
                "TITLE": "Offer was rejected",
                "SUB_TITLE": "In order to generate a new offer, contact your Agent."
            },
            "RETURN": {
                "TITLE": "Thanks!",
                "PENDING": "Your payment is being processed. We are still waiting for information on the status of the transaction.",
                "PAID": "Your payment was successful",
                "FAILURE": "Your payment has failed. We have sent an e-mail to the address you provided with a link enabling the re-execution of the transaction."
            },
            "EXPIRED": {
                "TITLE": "Link expired",
                "SUB_TITLE": "The link to the offer has expired.",
                "SUB_TITLE2": "Consult an agent to generate a new offer."
            },
            "ACCEPTED": {
                "TITLE": "The offer has been accepted",
                "SUB_TITLE": "Thank you for purchasing the policy.",
                "SUB_TITLE2": "The documents have been sent to the specified e-mail address."
            },
            "BROKEN_LINK": {
                "TITLE": "Invalid link",
                "SUB_TITLE": "The link to the offer is invalid.",
                "SUB_TITLE2": "Contact the Agent to generate a new link."
            },
            "POLICY": {
                "TITLE": "Your policy no. {{Number}}",
                "TITLE_MULTIPLE": "Your policy no. {{Numbers}}"
            },
            "PRINTOUT": {
                "ONLY_FROM_AGENT": "Available from agent"
            }
        },
        "SUMMARY": {
            "CITY_INFO_BOX": "Adding the city in which the offer was concluded is required"
        }
    },
    "gr": {
        "LOGIN": {
            "USERNAME": "Login",
            "PASSWORD": "Κωδικός πρόσβασης",
            "LOGIN_REQUIRED_INFO": "Εισαγάγετε την εγγεγραμμένη σύνδεση",
            "SEND_PASSWORD_HEADER": "Επαναφορά κωδικού",
            "RECOVER_HEADER": "Το e-mail εστάλη",
            "BUTTON": {
                "LOGIN": "Login"
            },
            "LOG_IN": "Log in",
            "APP_NAME": "EH24",
            "APP_NAME_ALTERNATIVE": "Portal Διαμεσολαβητή",
            "APP_SUBNAME": "Εφαρμογή υποστήριξης",
            "INFORMATION": "Χρησιμοποιήστε τα υπάρχοντα στοιχεία σύνδεσής σας στο σύστημα πωλήσεων. Εάν ο κωδικός πρόσβασής σας δεν λειτουργεί και έχει αλλάξει την τελευταία εβδομάδα, εισαγάγετε τον προηγούμενο.",
            "INVALID_CREDENTIALS": "Λάθος στοιχεία"
        },
        "LABEL": {
            "PASSWORD": {
                "RESET_INFORMATION": "Εισαγάγετε το όνομα χρήστη σας για να επαναφέρετε τον κωδικό πρόσβασής σας.",
                "RESET_DIALOG": "Εάν ο συγκεκριμένος λογαριασμός υπάρχει στο σύστημα, θα σταλεί ένα μήνυμα στο email που έχει εκχωρηθεί στον λογαριασμό με πληροφορίες σχετικά με τον τρόπο επαναφοράς του κωδικού πρόσβασης.",
                "INFORMATION": "Ζητήσατε αλλαγή κωδικού πρόσβασης. Ορίστε νέο. Ο κωδικός πρόσβασης πρέπει να περιέχει τουλάχιστον 8 χαρακτήρες και να περιέχει χαρακτήρες από τουλάχιστον τρεις από τις ακόλουθες ομάδες χαρακτήρων: <ul>\n<li> πεζά </li>\n<li> κεφαλαία </li>\n<li> αριθμοί </li>\n<li> ειδικοί χαρακτήρες </li>\n</ul>",
                "NEW_PASSWORD": "Νέος κωδικός",
                "NEW_PASSWORD_REPEAT": "Επανάλληψη νέου κωδικού",
                "RESET_DIALOG_SUCCESS": "Ο κωδικός πρόσβασης έχει αλλάξει, θα ανακατευθυνθείτε στη σελίδα σύνδεσης."
            },
            "FILE_NAME": "Όνομα αρχείου",
            "CALCULATION_PRINTOUT": "Έντυπο υπολογισμού",
            "OFFER_PRINTOUT": "Εκτύπωση προσφοράς",
            "POLICY_PRINTOUT": "Έντυπο συμβολαίου",
            "SUMMARY_PRINTOUT": "Έντυπο σύνοψης",
            "CERTIFICATE_PRINTOUT": "Πιστοποιητικό",
            "PAGINATOR": "{{page}} από {{pages}}",
            "SELLER": "Πωλητής",
            "ROLE": {
                "AGENT": "Αντιπρόσωπος",
                "WORKER": "Υπάλληλος",
                "DIRECT_SALES": "Αμεσες πωλήσεις",
                "SALES_MANAGER": "Διευθυντής πωλήσεων",
                "HEADQUATERS": "Headquarters"
            },
            "LOGGED_OUT_HEADER": "Πληροφορίες",
            "LOGGED_OUT_DESCRIPTION": "Η συνεδρία έληξε",
            "YES": "Ναι",
            "NO": "Όχι",
            "PICK": "Επιλέγω",
            "NAME": "Όνομα",
            "SURNAME": "Επώνυμο",
            "FAMILY_NAME": "Οικογενειακό όνομα",
            "PESEL": "PESEL",
            "NO_PESEL": "NO PESEL - αλλοδαπός",
            "FOREIGNER": "Αλλοδαπός",
            "POLICYHOLDER_INSURED": "Κάτοχος συμβολαίου / ασφαλιστής",
            "POLICYHOLDER": "Λήπτης ασφάλισης",
            "INSURED": "Ασφαλισμένος",
            "INSURED_NUMBER": "Ασφαλισμένος {{index}}",
            "ADDRESS": "Κύρια διεύθυνση",
            "ADDRESS_CORESPONDENCE": "Διεύθυνση αλληλογραφίας",
            "BOTH_ADDRESSES": "Κύρια διεύθυνση / διεύθυνση αλληλογραφίας",
            "POST_CODE": "Ταχυδρομικός κώδικας",
            "CITY": "Πόλη",
            "STREET_PREFIX": "Prefix",
            "STREET": "Οδός",
            "STREET_NUMBER": "Αριθμός",
            "DOOR_NUMBER": "Αριθμός διαμερίσματος",
            "DIFFERENT_CORRESPONDENCE_ADDRESS": "Διαφορετική διεύθυνση αλληλογραφίας",
            "INSURER_IS_INSURED": "Ο λήπτης είναι και ασφαλισμένος",
            "PREMIUM": "Ασφάλιστρο",
            "NIP": "NIP",
            "REGON": "REGON",
            "GO_TO_CALCULATION": "Μετάβαση στον υπολογισμό",
            "CITIZENSHIP": "Εθνικότητα",
            "DATE_OF_BIRTH": "Ημ/νία γέννησης",
            "GENDER": "Φύλο",
            "DOCUMENT_TYPE": "Τύπος αρχείου",
            "DOCUMENT_NUMBER": "Αιθμός αρχείου",
            "SUFFIX_KG": "kg",
            "SUFFIX_PLN": "zł",
            "SUFFIX_KM": "km",
            "SUFFIX_CM3": "cm³",
            "SUFFIX_KW": "kW",
            "CONFIRMATION": "Επιβεβαίωση",
            "POLICY_NUMBER": "Αριθμός συμβολαίου",
            "OC": "TPL",
            "AC": "AC",
            "SAVE_FAILED": "Υπάρχουν λάθη στη φόρμα",
            "GROWL_SUCCESS_TITLE": "Πληροφορίες",
            "GROWL_ERROR_TITLE": "Σφάλμα",
            "SELECT_FILTER": "Φίλτρο...",
            "SELECT_PLACEHOLDER": "-",
            "SUBMIT_CALCULATION": "Επιβεβαιώνω",
            "GENERATE_OFFER": "Δημιουργία προσφορά",
            "PHONE_NUMBER": "Τηλέφωνο",
            "EMAIL": "e-mail",
            "LOCATION_CHANGE_TITLE": "Ορισμός τοποθεσίας",
            "CREATION_DATE": "Ημερομηνία δημιουργίας",
            "CREATION_DATE_FROM": "Ημερομηνία δημιουργίας από",
            "CREATION_DATE_TO": "Ημερομηνία δημιουργίας έως",
            "FRONTIER_HEADER": "TPL συνόρων",
            "POLICYHOLDER_AND_INSURED": "Λήπτης / Ασφαλισμένος",
            "GO_TO_SUMMARY": "Μετάβαση στη σύνοψη",
            "PHONE_PREFIX": "Πρόθεμα",
            "VEHICLE_ORIGIN_COUNTRY": "Χώρα προέλευσης οχήματος",
            "COUNTRY": "Χώρα ",
            "PARTY_TYPE": "Τύπος μέρους",
            "COMPANY_NAME": "Ονομα εταιρείας",
            "COMPANY_NUMBER": "Αριθμός εταιρείας",
            "COMPANY_COUNTRY": "Χώρα της εταιρείας",
            "INSURANCE_PERIOD": "Ασφαλιστική περίοδος",
            "PAYMENT": "Πληρωμή",
            "PAYMENT_TYPE": "Τρόπος πληρωμής",
            "PAYMENT_TYPE_HEADER1": "Προτιμώμενος τρόπος πληρωμής - μετρητά.",
            "PAYMENT_TYPE_HEADER2": "Η επιλογή πληρωμής με τραπεζική μεταφορά θα πρέπει να επιλέγεται μόνο όταν δεν υπάρχουν διαθέσιμα μετρητά."
        },
        "ERROR": {
            "403": "Η πρόσβαση απορρίφθηκε",
            "500": "Internal server error",
            "PASSWORD_CHANGE_FAILURE": "Η αλλαγή κωδικού πρόσβασης απέτυχε",
            "TIMEOUT": "Λήξη χρονικού ορίου",
            "FAILED_ROUTING_HEADER": "Αποτυχία πλοήγησης",
            "FAILED_ROUTING_DESCRIPTION": "Δεν ήταν δυνατή η μετάβαση στο {{url}}. Ανακατευθυνθήκατε στην αρχική σελίδα.",
            "PAYMENT_FAILED": "Δεν ήταν δυνατή η έναρξη της πληρωμής."
        },
        "DASHBOARD": {
            "HEADER": "Ταμπλό",
            "NEW_OFFER": "Νέα προσφορά",
            "NEW_OFFER_SUB": "Περιουσία, Motor",
            "NEW_FRONTIER_SUB": "TPL συνόρου",
            "REGISTRY": "Αρχείο",
            "REGISTRY_SUB": "Υπολογισμοί, προσφορές και συμβόλαια"
        },
        "HEADER": {
            "OPEN_MENU": "Άνοιγμα μενού"
        },
        "BUTTON": {
            "BACK": "Πίσω",
            "CHANGE": "Αλλαγή",
            "SAVE": "Αποθήκευση",
            "CALCULATE": "Υπολογισμός",
            "CONFIRM": "Επιβεβαίωση",
            "CLOSE": "Κλείσιμο",
            "OK": "ΟΚ",
            "CANCEL": "Ακύρωση",
            "SEARCH": "Αναζήτηση",
            "EXPORT_CSV": "Εξαγωγή σε CSV",
            "ADD_INSURED": "Προσθήκη ασφαλισμένου",
            "REMOVE_INSURED": "Αφαίρεση ασφαλισμένου",
            "DOWNLOAD_ALL": "Λήψη όλων",
            "GO_TO_CALCULATION": "Μετάβαση στον υπολογισμό",
            "GO_TO_SUMMARY": "Μετάβαση στην σύνοψη",
            "NEXT": "Επόμενο",
            "ADD_CONTACT_DATA": "Προσθήκη δεδομένων επαφής",
            "EDIT_CONTACT_DATA": "Επεξεργασία δεδομένων επαφής",
            "DELETE_CONTACT_DATA": "Διαγραφή δεδομένων επαφής",
            "ADD_CESSION": "Προσθήκη εκχώρησης",
            "EDIT_CESSION": "Επεξεργασία εκχώρησης",
            "DELETE_CESSION": "Διαγραφή εκχώρησης",
            "ACCEPT_OFFER": "Εγκρίνετε την προσφορά",
            "SEND_OFFER": "Στείλτε προσφορά στο e-mail",
            "GO_TO_OFFER": "Πηγαίνετε στην προσφορά",
            "PAY": "Πληρωμή",
            "PAYMENT_PENDING": "Πληρωμή σε εξέλιξη",
            "PAYMENT_SUCCESS": "Επιτυχία πληρωμής"
        },
        "OFFER_CONFIG": {
            "NEW_OFFER": "Νέα προσφορά",
            "HEADER": "Διαμόρφωση προσφοράς",
            "POLICY_DATA": "Στοιχεία συμβολαίου",
            "TYPE_OF_POLICY": "Τύπος συμβολαίου",
            "LAST_YEAR_POLICY_NR": "Αριθμός συμβολαίου προηγούμενου έτους",
            "PROTECTION_PERIOD": "Ασφαλιστική περίοδος",
            "INSURANCE_DATE_FROM": "Ημ/νία ασφάλισης από ",
            "INSURANCE_DATE_TO": "Ημ/νία ασφάλισης έως",
            "DATE_RANGE": "Εύρος ημερομηνίας",
            "ESTATE_DATA": "Στοιχεία περιουσίας",
            "ESTATE_TYPE": "Τύπος ακινήτου",
            "ADDITIONAL_ESTATE_PROPERTIES": "Πρόσθετα ακίνητα",
            "IS_RENTED": "Το ακίνητο ενοικιάζεται",
            "HAS_SAFE_DOOR": "Πόρτες ασφαλείας",
            "HAS_ALARM": "Συναγερμός",
            "IS_UNDER_PROTECTION": "Μόνιμη επιτήρηση ",
            "INSURANCE_COVERAGE": "Ασφαλιστική κάλυψη",
            "FIRE_RANDOM_EVENTS": "Πυρός και απρόσμενα γεγονότα - Κατά παντός κινδύνου",
            "THEFT": "Κλοπή - Κατά παντός κινδύνου",
            "PREMIUM": "Ασφάλιστρο",
            "CLIENTS": "Πελατες",
            "WELTH": "Περιουσια",
            "WELTH_POLICY": "Περιουσία- συμβόλαιο {{number}}",
            "COMMUNICATION": "Motor",
            "COMMUNICATION_POLICY": "Motor - συμβόλαιο {{number}}",
            "FRONTIER": "TPL συνόρων",
            "FRONTIER_POLICY": "TPL συνόρων - συμβόλαιο {{number}}",
            "APARTMENT": "Διαμέρισμα",
            "OUTBUILDING_GARAGES": "Εξωτερικά κτίρια/ γκαράζ",
            "EQUIPMENT": "Εξοπλισμός",
            "PERSONAL_THINGS": "Προσωπικά αντικείμενα",
            "GARDEN_ARCHITECTURE": "Αρχιτεκτονική κήπων",
            "FLOOD_RISK": "Πλυμμήρα",
            "OC_PERSONAL": "Αστική ευθύνη",
            "INSURED_NUMBER": "Πλήθος ασφαλισμένων",
            "HOME_ASSISTANCE": "Βοήθεια στο σπίτι",
            "PAYMENTS": "Πληρωμές",
            "INSTALLMENTS_DEFERMENT": "Πλήθος δόσεων / αναβολή δόσης",
            "INSTALLMENTS": "Πλήθος δόσεων",
            "DEFERMENT": "Αναβολή δόσης",
            "DATE_OF_PAYMENT": "Ημερομηνία πληρωμής",
            "AMOUNT_OF_INSTALLMENT": "Ποσό δόσης",
            "TOTAL_PREMIUM": "Συνολικό ασφάλιστρο",
            "INSURANCE_SCOPE_HOUSE": "Κατοικία",
            "INSURANCE_SCOPE_FLAT": "Διαμέρισμα"
        },
        "CALCULATION_TYPE": "Τύπος",
        "BRANCH": "Κατάστημα",
        "AGENCY": "Πρακτορείο",
        "OFWCA": "OFWCA",
        "PRODUCT": {
            "CONFIGURE_PROPERTY_AGAIN": "Διαμορφώστε ξανά το προϊόν περιουσίας",
            "CONFIGURE_MOTOR_AGAIN": "Διαμορφώστε ξανά το προϊόν αυτοκινήτου"
        },
        "TOOLTIP": {
            "DELETE_PRODUCT": "Διαγραφή προϊόντος",
            "EDIT_PRODUCT": "Επεξεργαία προϊόντος",
            "EDIT_POLICYHOLDER": "Επεξεργασία λήπτη",
            "DELETE_INSURED": "Διαγραφή ασφαλισμένου",
            "EDIT_INSURED": "Επεξεργασία ασφαλισμένου",
            "EDIT_PREMIUM": "Επεξεργασία ασφαλίστρου"
        },
        "MODAL": {
            "DELETE_PRODUCT_CONFIRMATION": "Θέλετε να αφαιρέσετε το προϊόν;",
            "DELETE_CONTACT_DATA": "Θέλετε να διαγράψετε τα στοιχεία επικοινωνίας;",
            "DELETE_INSURED_CONFIRMATION": "Θέλετε να αφαιρέσετε τον ασφαλισμένο;",
            "CHANGE_CHARACTER_CONFIRMATION": "Θέλετε να αλλάξετε τον χρήστη σε {{name}}?",
            "DELETE_CESSION_CONFIRMATION": "Είστε βέβαιοι ότι θέλετε να διαγράψετε την εκχώρηση;",
            "SEND_OFFER": "Είστε βέβαιοι ότι θέλετε να στείλετε στον πελάτη μια προσφορά;",
            "PROVIDE_POLICYHOLDER_CONTACT_DATA": "Εισαγάγετε το email του ασφαλισμένου και επιλέξτε τις απαιτούμενες συναινέσεις",
            "ASM_TITLE": "Λυπούμαστε",
            "ASM_MESSAGE": "Το αίτημά σας δεν μπόρεσε να επεξεργαστεί. <br/> Support ID: <b> {{supportId}} </b>"
        },
        "GROWL": {
            "PRODUCT_DELETED": "Το προϊόν αφαιρέθηκε",
            "INSURED_DELETED": "Ο ασφαλισμένος αφαιρέθηκε",
            "CESSION_DELETED": "Η εκχώρηση έχει διαγραφεί",
            "LANGUAGE_SET": "Η γλώσσα {{lang}} έχει οριστεί",
            "LANGUAGE_NOT_SET": "Η γλώσσα δεν έχει οριστεί: {{lang}}"
        },
        "REGISTRY": {
            "LIST": "Μητρώο - προσφορές και υπολογισμοί",
            "CONFIGRATIONS_OFFERS": "Διαμορφωση και λιστα προσφορων",
            "POLICIES": "Λιστα συμβολαιων",
            "IOFFER": "iOffer",
            "INSURED": "Ασφαλισμένος",
            "PREMIUM": "Ασφάλιστρο",
            "CALCULATION_TYPE": "Τύπος",
            "INSURANCE_PERIOD": "Ασφαλιστική περίοδος",
            "OFFER_NR_CALCULATION": "Αριθμός προσφοράς / Υπολογισμός",
            "AGENT": "Πράκτορας",
            "OFWCA": "OFWCA",
            "POLICY_NUMBER": "Αριθμός συμβολαίου",
            "SIGNING_FROM": "Υπογραφή από",
            "SIGNING_TO": "Υπογραφή σε",
            "INSURANCE_FROM": "Ασφάλιση από",
            "INSURANCE_TO": "Ασφάλιση έως"
        },
        "OFFER_CALCULATION_NUMBER": "Προσφορά / αριθμός υπολογισμού",
        "OFFER": {
            "HEADER": "Προσφορά {{number}}",
            "INFO_BOX": "Η προσφορά είναι δεσμευτική και έχει αποκλειστεί για επεξεργασία. Οι όροι του ισχύουν μέχρι το τέλος της ημέρας. Για να κάνετε αλλαγές, αποσύρετε την προσφορά για επεξεργασία.",
            "INFO_BOX_2": "Προσοχή-η επιστροφή στην επεξεργασία της προσφοράς θα οδηγήσει σε επαναυπολογισμό του ασφαλίστρου",
            "BACK_TO_CALCULATION": "Επεξεργασία προσφοράς",
            "BACK_TO_CALCULATION_CONFIRMATION": "Είστε βέβαιοι ότι επιθυμείτε την επαναφορά του υπολογισμόυ;",
            "ACCEPT_OFFER": "Αποδοχή",
            "REJECT_OFFER": "Απόρριψη",
            "EMPTY": "Δεν βρέθηκαν αποτελέσματα για τα κριτήρια αναζήτησης. Ελέγξτε τα στιοχεία που εισάγατε."
        },
        "POLICY": {
            "HEADER": "Συμβόλαιο {{number}}",
            "HEADER_MULTIPLE": "Συμβόλαια {{number}}",
            "EMPTY": "Δεν βρέθηκαν αποτελέσματα για τα κριτήρια αναζήτησης. Ελέγξτε τα στιοχεία που εισάγατε."
        },
        "TIMETABLE": {
            "TITLE": "Χρονοδιάγραμμα",
            "SUBTITLE": "Χρονοδιάγραμμα διοίκησης ",
            "HEADER": "Χρονοδιάγραμμα εργασίας",
            "ADD_NEW_TERM": "Προσθήκη όρου",
            "TURN_APP_IN": "Ενεργοποιήστε την εφαρμογή τις επόμενες ημέρες",
            "EXTRA_OPTIONS": "Επιπλέον επιλογές",
            "TURN_SALES_PATH": "Απενεργοποιήστε τη διαδρομή πωλήσεων",
            "TURN_OFF_REGISTRY": "Απενεργοποιήστε το μητρώο",
            "DATE_FROM": "Ημ/νία έναρξης",
            "DATE_TO": "Ημ/νία λήξης",
            "REMOVE_DIALOG_TITLE": "Είστε βέβαιοι;",
            "REMOVE_DIALOG_DESCRIPTION": "Προσπαθείτε να διαγράψετε ένα στοιχείο χρονοδιαγράμματος."
        },
        "CONTACT_DATA_DIALOG": {
            "SUBHEADER": "Θα είναι ευκολότερο για εμάς να επικοινωνήσουμε μαζί σας εάν μας δώσετε e-mail και αριθμό τηλεφώνου."
        },
        "LOCATION_DIALOG": {
            "SUBHEADER": "Συμπληρώστε την τοποθεσία όπου έγινε η συμφωνία."
        },
        "MOTOR_CONFIG": {
            "INSURED_DATA": "Στοιχεία ασφαλισμένου",
            "INSURED_NAME_PESEL": "Όνομα, επώνυμο",
            "DRIVING_LICENSE_DATE": "Ημ/νία έκδοσης άδειας οδήγησης",
            "NO_DRIVING_LICENSE": "Χωρίς άδεια οδήγησης",
            "MOTOR_DATA_EUROTAX": "Στοιχεία οχήματος - Eurotax",
            "EUROTAX_CODE": "Eurotax ID",
            "CALCULATE_EUROTAX_VALUE": "Υπολογισμός",
            "MOTOR_TYPE": "Τύπος οχήματος",
            "MANUFACTURE_YEAR": "Έτος κατασκευής",
            "MAKE": "Κατασκευαστής",
            "MODEL": "Μοντέλο",
            "BODY_TYPE": "Σωματότυπος",
            "DOOR_NUMBER": "Αριθμός θυρών",
            "FUEL_TYPE": "Τύπος καυσίμου",
            "ENGINE_SIZE": "Ικανότητα μηχανής",
            "NOT_IN_EUROTAX": "Το όχημα δεν βρέθηκε στη λίστα του Eurotax",
            "VEHICLE_DETAILS": "Στοιχεία οχήματος",
            "MILEAGE": "Σειρά μαθημάτων",
            "FIRST_REGISTRATION_DATE": "Ημ/νία πρώτης εγγραφής",
            "REGISTRATION_NUMBER": "Αιθμός μητρώου",
            "VIN": "VIN",
            "MOTOR_VALUE": "Αξία οχήματος",
            "UNUSUAL": "Ασυνήθιστη χρήση",
            "RIGHT_STEERING_WHEEL": "Δεξιοτίμονο",
            "LEASING": "Leasing",
            "IS_IN_LEASING": "Το όχημα είναι μισθωμένο",
            "LESSER_NAME": "Όνομα εκμισθωτή",
            "LESSER_ADDRESS": "Διεύθυνση εκμισθωτή",
            "KW": "Ισχύς",
            "TRANSMISSION": "Μεταβίβαση",
            "TRANSMISSIONS_NUMBER": "Αριθμός γραναζιών",
            "NUMBER_OF_SEATS": "Πλήθος θέσεων",
            "VERSION": "Έκδοση",
            "EUROTAX_ID": "Eurotax",
            "PRODUCT_YEARS": "MOTOR_CONFIG.PRODUCT_YEARS",
            "MOTOR_DATA_MANUAL": "Στοιχεία οχήματος - χειρόγραφη καταχώρηση",
            "LOAD_CAPACITY": "Χωρητικότητα",
            "MAXIMUM_WEIGHT": "Μέγιστο βάρος",
            "CLAIMS_HISTORY": "Ιστορικό ζημιών",
            "INSURANCE_COUNTINUITY": "Συνέχιση ασφάλισης σε χρόνια",
            "CLAIMS_2YEARS": "Ζημιές τα τελευταία 2 χρόνια",
            "CLAIMS_5YEARS": "Ζημιές τα τελευταία 5 χρόνια",
            "SUM_OF_INSURANCE": "Κεφάλαιο ασφάλισης",
            "ACCORDING_TO_LAW": "Σύμφωνα με τον νόμο",
            "INSURANCE_SCOPE_OC": "TPL ιδιοκτήτη οχήματος",
            "INSURANCE_SCOPE_AC": "AC - απώλεια και ζημιά στο όχημα",
            "DAMAGE_LIQUIDATION": "Μέθοδος ρευστοποίησης",
            "ADDON_NNW": "Ασφάλεια προσωπικού ατυχήματος",
            "ADDON_ASSSTANCE": "Βοήθεια - αποτυχία και ατύχημα",
            "AUTOCASCO_UNAVAILABLE": "Η ασφάλεια AC δεν είναι διαθέσιμη καθώς η βάση δεδομένων Eurotax δεν έχει αποτίμηση για αυτό το όχημα. Ελέγξτε την ορθότητα των δεδομένων που εισάγατε."
        },
        "FRONTIER_CONFIG": {
            "FRONTIER": "Ασφάλιση συνοριακής αστικής ευθύνης"
        },
        "ASIDE_PARTY": {
            "EDIT_POLICYHOLDER": "Επεξεργασία λήπτη",
            "EDIT_INSURED": "Επεξεργασία ασφαλισμένου",
            "ADD_INSURED": "Νέος ασφαλισμένος"
        },
        "CLIENTS": {
            "HEADER": "Πελάτες"
        },
        "MOTOR_MAKE_MODEL": "Κατασκευαστής και μοντέλο",
        "INSURANCE_PERIOD": "Ασφαλιστική περίοδος",
        "INSURANCE_SCOPE": " Είδος ασφάλισης",
        "CONFIGURE": "Διαμόρφωση",
        "PREVIEW": "Προεπισκόπηση ",
        "CLIENT_DECLARATIONS_CONDITIONS": "Ρήτρες και δηλώσεις πελατών",
        "CLIENT_DECLARATION_INFO": "Δήλωση για τη διαχείριση δεδομένων από την STU ERGO Hestia S.A., την επεξεργασία τους, τη δυνατότητα προβολής και ενημέρωσης των δεδομένων από τον Πελάτη και το δικαίωμα της STU ERGO Hestia να έχει πρόσβαση σε δεδομένα που συλλέγονται στο UFG.",
        "CLIENT_DECLARATION_1": "Δηλώνω ότι έχω διαβάσει το περιεχόμενο της ρήτρας πληροφοριών του διαχειριστή",
        "CLIENT_DECLARATION_2": "Δηλώνω ότι μου έχει παρουσιαστεί και ότι έχω διαβάσει το περιεχόμενο του πληρεξουσίου για τη σύναψη ασφαλιστικής σύμβασης για λογαριασμό της STU ERGO Hestia S.A. στο Σοπότ. Πριν από τη σύναψη της σύμβασης, έλαβα τους Γενικούς Όρους και τις Προϋποθέσεις Ασφάλισης με συνημμένα βάσει των οποίων συνήφθη η σύμβαση και έχω διαβάσει και αποδεχτεί το περιεχόμενό τους. Τα στοιχεία της ηλεκτρονικής αίτησης είναι αληθή και δόθηκαν εξ όσων γνωρίζω.",
        "AGENT_DECLARATIONS": "Δηλώσεις πρακτόρων",
        "SELECT_ALL_DECLARATIONS": "Επιλέξτε όλες τις ζημιές του πράκτορα",
        "AGENT_DECLARATION_INFO": "Δηλώνω ότι πριν από τη σύναψη της ασφαλιστικής σύμβασης:",
        "AGENT_DECLARATION_1": "Διεξάγω μελέτη των αναγκών και των ασφαλιστικών απαιτήσεων του πελάτη,",
        "AGENT_DECLARATION_2": "Έχω παράσχει στον πελάτη τις πληροφορίες σχετικά με τον διανομέα που απαιτούνται από το νόμο,",
        "AGENT_DECLARATION_3": "Έχω παράσχει στον Πελάτη ένα τυποποιημένο έγγραφο που περιέχει τις νόμιμες αντικειμενικές πληροφορίες σχετικά με το προτεινόμενο ασφαλιστικό προϊόν.",
        "READ_MORE": "Διαβάστε περισσότερα...",
        "DISTRIBUTOR_DECLARATIONS": "Δηλώσεις διανομής",
        "DISTRIBUTOR_DECLARATION_INFO": "Δηλώνω ότι στο σύστημα απευθείας πωλήσεων εξ αποστάσεως, πριν από τη σύναψη της ασφαλιστικής σύμβασης, έλαβαν χώρα τα εξής:",
        "DISTRIBUTOR_DECLARATION_1": "διερεύνηση και καθορίσμός των απαιτήσεων και των ασφαλιστικών μου αναγκών,",
        "DISTRIBUTOR_DECLARATION_2": "παροχή νόμιμων πληροφοριών σχετικά με τον διανομέα,",
        "DISTRIBUTOR_DECLARATION_3": "παροχή σε κατανοητή μορφή, ως τυποποιημένο έγγραφο, τιων νομικά απαιτούμενων αντικειμενικών πληροφοριών για το προτεινόμενο ασφαλιστικό προϊόν.",
        "CLIENT_CONDITIONS": "Συναίνεση ",
        "CLIENT_CONDITION_1": "Συγκατάθεση για λήψη εμπορικών πληροφοριών με ηλεκτρονικά μέσα",
        "CLIENT_CONDITION_1_EXTENDED": "Συγκατάθεση για λήψη εμπορικών πληροφοριών με ηλεκτρονικά μέσα. Η μη επιλογή του πλαισίου συναίνεσης σημαίνει άρνηση συναίνεσης.\n\nΣυμφωνώ να λαμβάνω εμπορικές πληροφορίες από την Sopockie Towarzystwo Ubezpieczeń ERGO Hestia SA στο Σόποτ, χρησιμοποιώντας μέσα επικοινωνίας εξ αποστάσεως (τηλέφωνο, ηλεκτρονικό ταχυδρομείο, ατομικός λογαριασμός Διαδικτύου που παρέχεται από τον Ασφαλιστή) χρησιμοποιώντας τα στοιχεία επικοινωνίας που παρέχονται από εμένα.",
        "CLIENT_CONDITION_2": "Συγκατάθεση για λήψη πληροφοριών ηλεκτρονικά",
        "CLIENT_CONDITION_2_EXTENDED": "«Συγκατάθεση για λήψη πληροφοριών με ηλεκτρονικά μέσα (σύναψη / κάλυψη και εκτέλεση της ασφαλιστικής σύμβασης) της STU ERGO Εστία Α.Ε. σχετικά με τη συγκατάθεση για τα ακόλουθα.\n\nΖητώ από την Sopockie Towarzystwo Ubezpieczeń ERGO Hestia SA στο Σόποτ να αποστείλει αλληλογραφία σχετικά με την εκτέλεση όλων των ασφαλιστικών δραστηριοτήτων μέσω επικοινωνίας εξ αποστάσεως (τηλέφωνο, e-mail, ατομικός λογαριασμός Διαδικτύου που παρέχεται από τον Ασφαλιστή) στα στοιχεία επικοινωνίας που έχω δώσει και απαντήσεις σε υποβληθείσες καταγγελίες στη διεύθυνση ηλεκτρονικού ταχυδρομείου που αναφέρεται στα δεδομένα. Αναλαμβάνω να ενημερώσω τα δεδομένα».",
        "CLIENT_CONDITION_3": "Συναινώ στη σύναψη της ασφαλιστικής σύμβασης με τους όρους που καθορίζονται στην προσφορά που μου παρέχεται χρησιμοποιώντας μέσα επικοινωνίας εξ αποστάσεως.",
        "PASSWORD": "Κωδικός πρόσβασης",
        "LOG_IN": "Log in",
        "INFO": {
            "USE_YOUR_CREDENTIALS": "Εισάγετε τα στοιχεία σύνδεσης που χρησιμοποιείτε στο σύστημα πωλήσεων",
            "ADD_CONTACT_DATA": "Η παροχή διεύθυνσης e-mail και αριθμού τηλεφώνου θα διευκολύνει την επαφή με τον πελάτη στο μέλλον",
            "OFFER_SAVED": "Η προσφορά αποθηκεύτηκε"
        },
        "CLIENT_DATA": "Στοιχεία πελάτη",
        "POLICYHOLDER": "Λήπτης",
        "NAME_SURNAME_FAMILYNAME": "Όνομα / Επώνυμο",
        "PESEL": "PESEL ",
        "NO_PESEL": "No PESEL",
        "NATIONALITY": "Εθνικότητα",
        "BIRTH_DATE": "Ημ/νία γέννησης",
        "DOCUMENT_TYPE": "Τύπος αρχείου",
        "DOCUMENT_NUMBER": "Αριθμός αρχείου",
        "RESIDENTIAL_ADDRESS": "Διεύθυνση κατοικίας",
        "POSTAL_CODE": "Ταχ. κώδικας",
        "CITY": "πόλη",
        "STREET": "οδός",
        "AVENUE": "λεωφόρος",
        "SQUARE": "τετράγωνο",
        "HOUSE_NUMBER": "αριθμός",
        "HOUSE_UNIT_NUMBER": "αρ. διαμερίσματος",
        "OTHER_MAIL_DROP": "Άλλη ταχυδρομική διεύθυνση",
        "POLICYHOLDER_IS_INSURED": "Ο λήπτης είναι ασφαλισμένος",
        "OFFER_CALCULATION": "Υπολογισμός προσφοράς",
        "INSURED": "Ασφαλισμένος",
        "DIALOG": {
            "DELETE_CLIENT": "Διαγραφή πελάτη;",
            "DELETE_CALCULATION": "Εϊστε βέβαιοι ότι θέλετε να διαγράψετε τα στοιχεία;",
            "ACCEPT_OFFER": "Είστε βέβαιοι ότι θέλετε να αποδεχτείτε την προσφορά;",
            "REJECT_OFFER": "Είστε βέβαιοι ότι θέλετε να απορρίψετε την προσφορά;"
        },
        "CLIENT": "Πελάτης",
        "POLICYHOLDER_DATA": "Στοιχεία λήπτη",
        "INSURED_DATA": "Στοιχεία ασφαλισμένου",
        "ASSETS": "Περιουσιακά στοιχεία",
        "PAYMENTS": "Πληρωμή",
        "FULL_INSURANCE_PREMIUM": "Συνολικό ασφάλιστρο",
        "PROPERTY_TYPE": "Τύπος περιουσίας",
        "PROPERTY_ADDRESS": "Διεύθυνση περιουσίας",
        "INSTALLMENT_NUMBER": "Αριθμός δόσης",
        "INSTALLMENT_AMOUNT": "Ποσό δόσης",
        "CALCULATION_SUBJECT": {
            "NEW_POLICY": "Νέο συμβόλαιο",
            "CONTINUATION": "Συνέχεια συμβολαίου"
        },
        "RISK_HOME_ASSISTANCE": "Βοήθεια στο σπίτι",
        "SUM_INSURED_200000": "200 000 zł",
        "INSTALLMENT_POSTPONEMENT": "Αναβολή δόσεων",
        "NAME_SURNAME_COMPANY": "Όνομα, επώνυμο / επωνυμία εταιρείας",
        "CALCULATION_SUMMARY": "Σύνοψη υπολογισμού",
        "CONTRACT_DATE_PLACE": "Ημερομηνία και τόπος σύμβασης",
        "POLICYHOLDER_CONTACT_DATA": "Στοιχεία επικοινωνίας αντισυμβαλλομένου",
        "CONTACT_DATA": "Στοιχεία επικοινωνίας",
        "CESSIONARY_DATA": "Στοιχεία εκχώρησης",
        "CESSIONARY_TYPE": "Τύπος εκχώρησης",
        "CESSIONARY_NAME": "Όνομα εκχώρησης",
        "ORIGIN_COUNTRY": "Χώρα προέλευσης",
        "ADDRESS": "Διεύθυνση",
        "POLICY_DATE_AND_CITY": "Ημ/νία συμβολαίου, πόλη",
        "INSURED_OBJECT": "Ασφαλισμένο αντικείμενο",
        "POLICY_DIALOG": {
            "HEADER": "Πληροφορίες"
        },
        "CONFIRMATION": {
            "ISSUE_POLICY_FROM_CALCULATION": "Επιβεβαιώστε την ορθότητα των συμπληρωμένων δεδομένων. Μετά την έγκριση της πολιτικής, δεν είναι δυνατή η επιστροφή στην έκδοση.",
            "ISSUE_POLICY_FROM_OFFER": "Είστε βέβαιοι ότι θέλετε να εγκρίνετε αυτήν την προσφορά;"
        },
        "SCHEDULE": {
            "DATES": "Εύρος ημερομηνιών",
            "AUTHOR": "Συγγραφέας",
            "OPERATIONS": "Λειτουργίες",
            "TOOLTIP": {
                "EDIT_ENTRY": "επεξεργασία",
                "DELETE_ENTRY": "διαγραφή"
            },
            "ENTRY_DELETED": "Η καταχώριση διαγράφηκε",
            "ENTRY_ADDED": "Η καταχώριση προστέθηκε",
            "ENTRY_EDITED": "Η καταχώριση επεξεργάστηκε",
            "SALE_IS_NOT_ACTIVE": "Η μονάδα πωλήσεων είναι απενεργοποιημένη αυτήν τη στιγμή.",
            "APPLICATION_IS_NOT_ACTIVE": "Η μονάδα πωλήσεων είναι απενεργοποιημένη αυτήν τη στιγμή. Το έγγραφο είναι διαθέσιμο σε λειτουργία μόνο για ανάγνωση."
        },
        "CLIENT_OFFER": {
            "YOUR_POLICY": "Η πολιτική σας",
            "THANKS_FOR_PURCHASE": "Σας ευχαριστούμε που αγοράσατε την πολιτική. Τα έγγραφα έχουν αποσταλεί στη διεύθυνση ηλεκτρονικού ταχυδρομείου που παρέχεται.",
            "OFFER_REJECTED": "Η προσφορά απορρίφθηκε",
            "CONTACT_AGENT_FOR_NEW_OFFER": "Για να δημιουργήσετε μια νέα προσφορά, επικοινωνήστε με τον αντιπρόσωπό σας"
        },
        "IOFFER": {
            "VERIFICATION": {
                "TITLE": "Η προσφορά σας",
                "SUBTITLE": "Εισαγάγετε τον αριθμό PESEL σας για πρόσβαση στην προσφορά. Στο επόμενο βήμα, θα μπορείτε να αποδεχτείτε την προσφορά, να πληρώσετε και να εκτυπώσετε το συμβόλαιο.",
                "SUBTITLE2": "Οι όροι της προσφοράς ισχύουν μέχρι το τέλος της ημέρας.",
                "ERROR": {
                    "WRONG_PESEL": "Υπό την προϋπόθεση ότι το PESEL δεν είναι έγκυρο"
                },
                "GO_TO_OFFER": "Πηγαίνετε στην προσφορά"
            },
            "OFFER": {
                "OFFER_NUMBER": "Προσφορά {{number}}"
            },
            "CLAUSES": {
                "INFO": {
                    "CHECKBOX_NOT_CHECKED": "Κατά τη διάρκεια της συνομιλίας, ο Πράκτορας σημείωσε τις ακόλουθες ρήτρες, δηλώσεις και συναινέσεις που απαιτούνται για τη σύναψη ενός συμβολαίου ασφάλισης εξ αποστάσεως. <br>\nΕάν δεν συμφωνείτε με αυτές ή δεν επιβεβαιώσετε τις Δηλώσεις του Αντιπροσώπου, απορρίψτε την προσφορά και επικοινωνήστε ξανά με τον Ασφαλιστικό Σύμβουλο. <br>\nΗ αποδοχή ισοδυναμεί με συναίνεση στη σύναψη της ασφαλιστικής σύμβασης με τους όρους που καθορίζονται στην προσφορά που παρέχεται με χρήση μέσων επικοινωνίας εξ αποστάσεως."
                }
            },
            "CHECK_DATA_INFO": "Ελέγξτε το εύρος και το ασφαλιστικό ποσό κατεβάζοντας το έγγραφο εκτύπωσης προσφοράς.",
            "REJECTED": {
                "TITLE": "Η προσφορά απορρίφθηκε",
                "SUB_TITLE": "Για να δημιουργήσετε μια νέα προσφορά, επικοινωνήστε με τον αντιπρόσωπό σας."
            },
            "RETURN": {
                "TITLE": "Ευχαριστούμε!",
                "PENDING": "Η πληρωμή σας είναι υπό επεξεργασία. Ακόμη αναμένουμε πληροφορίες για την κατάσταση της συναλλαγής.",
                "PAID": "Η πληρωμή σας ήταν επιτυχής",
                "FAILURE": "Η πληρωμή σας απέτυχε. Έχουμε στείλει ένα e-mail στη διεύθυνση που καταχωρίσατε με έναν σύνδεσμο που επιτρέπει την εκ νέου εκτέλεση της συναλλαγής."
            },
            "EXPIRED": {
                "TITLE": "Ο σύνδεσμος έληξε",
                "SUB_TITLE": "Ο σύνδεσμος για την προσφορά έχει λήξει.",
                "SUB_TITLE2": "Συμβουλευτείτε έναν αντιπρόσωπο για να δημιουργήσετε μια νέα προσφορά."
            },
            "ACCEPTED": {
                "TITLE": "Η προσφορά έγινε αποδεκτή",
                "SUB_TITLE": "Σας ευχαριστούμε που αγοράσατε την πολιτική.",
                "SUB_TITLE2": "Τα έγγραφα έχουν σταλεί στην καθορισμένη διεύθυνση ηλεκτρονικού ταχυδρομείου."
            },
            "BROKEN_LINK": {
                "TITLE": "Μη έγκυρος σύνδεσμος",
                "SUB_TITLE": "Ο σύνδεσμος προς την προσφορά δεν είναι έγκυρος.",
                "SUB_TITLE2": "Επικοινωνήστε με τον πράκτορα για τη δημιουργία του συνδέσμου."
            },
            "POLICY": {
                "TITLE": "Ο αριθμός συμβολαίου σας. {{Number}}",
                "TITLE_MULTIPLE": "Οι αριθμοί συμβολαίων σας. {{Numbers}}"
            },
            "PRINTOUT": {
                "ONLY_FROM_AGENT": "Διαθέσιμο από τον εκπρόσωπο"
            }
        },
        "SUMMARY": {
            "CITY_INFO_BOX": "Απαιτείται η προσθήκη της πόλης στην οποία ολοκληρώθηκε η προσφορά"
        }
    }
};